import React, {Component, useLayoutEffect} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import {Link} from 'react-router-dom';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {Tab, Tabs} from "react-bootstrap";
import * as moment from "moment";
import {Button, ModalFooter, ModalHeader, Table} from "reactstrap";
import ModalD from "react-awesome-modal";
import {CSVLink} from "react-csv";
import loaderGIF from "../assets/loader.gif";
import {AmountInWords}  from "./amountToWord";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
var yesterday = new Date(Date.now() + 360 * 60 * 60 * 1000);

var yestSend = moment(yesterday).format('YYYY-MM-DD');


class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order_response: [],
      loading: true,
      viewType: 'tableView',
      title: 'Orders',
      inwordboxResponse: [],
      inwardBoxes: [],
      boxSerialNumber: '',
      awb: '',
      logistic: '',
      challanNumber: '',
      _notificationSystem: null,
      orderId: '',
      boxDetailResponse: [],
      productSerialNumber: '',
      verifyInventoryView: false,
      orderDetailResponse: [],
      encodedOrderId: '',
      orderDetailsTableData: [],
      orderDetailOtpView: false,
      otpValue: '',
      verifyROView: false,
      facilityType: '',

      loader:'',
      emptyRO:false,

      orderReturnData: [],
      ROPending: [],
      ROBoxNumber: '',
      ROBoxid: '',
      ROOrderID: '',
      ROOrderStatus: '',
      ROOrderType: '',
      ROScanData: [],
      ScanEnterVerify: false,
      ROOTP: 'NA',

      PROorderReturnData: [],
      PROPending: [],
      PROBoxNumber: '',
      PROBoxid: '',
      PROOrderID: '',
      PROOrderStatus: '',
      PROOrderType: '',
      PROScanData: [],
      PROScanEnterVerify: false,
      PRORequestType: '',
      expectDeliverDate: yestSend,

      disBoxDetails: [],
      disOrderID: '',
      disOrderName: '',
      disawbNumber: '',
      disdeliveryDate: '',
      disemployeeId: '',
      dislogisticDetails: [],
      disuserid: '',
      disSelectlogisticName: '',
      disSelectlogisticId: '',
      AWBTitle: 'AWB',
      AwbEmp: '',
      BOX: '',

      pdfBilledTo: [],
      pdfBoxDetails: [],
      pdfInvoiceDetails: [],
      pdfOrderItem: [],
      pdfShippedTo: [],
      pdfCustOrderItem: [],

      pdfTQty: '0',
      pdfTRate: '0.00',
      pdfTAmount: '0.00',

      FOScanSerialNo: '',
      FOTempAssest: [],
      FODisConsumable: [],
      FODisAssest: [],

      DisputAsset: [],
      DisputModal: false,

      ExcelHeaders: [
        {label: "Order Id", key: "OrderId"},
        {label: "Order Type", key: "OrderType"},
        {label: "Created Date", key: "CreatedDate"},
        {label: "Order Status", key: "OrderStatus"},
        {label: "Ordered Quantity", key: "OrderedQuantity"},
        {label: "Pending Quantity", key: "PendingQuantity"},
        {label: "Actions", key: "Actions"},
        {label: "Return Action", key: "ReturnAction"},
        {label: "AWB Number", key: "AWBNumber"}
      ],
      ExcelData: [],

      BomModal: false,
      BomproductSerialNumber: '',
      BomorderReturnData: [],
      BomROPending: [],
      BomROBoxNumber: '',
      BomROBoxid: '',
      BomROOrderID: '',
      BomROOrderStatus: '',
      BomROOrderType: '',
      BomROScanData: [],
      BomScanEnterVerify: false,
      BomROOTP: 'NA',
      BomAssetId: '',

      HideShowScan: 'block',

      interval: 0,
      setStartDate: new Date(),
      setEndDate: new Date(),
      searchOrderType:'all'
    }
  }


  componentDidMount() {

    this.setState({_notificationSystem: this.refs.notificationSystem});
    this.refreshOrders();
    this.setState({
      loader:'none',
    })

  }

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"/>,
      message: (
        <div>
          {msg}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 0
    });
  };

  async handleView(e) {

    var viewType = e.target.text;
    var concatedOrderId = e.target.name.split(',');
    var encodedOrderId = concatedOrderId[0];
    var orderId = concatedOrderId[1];
    var facilityType = concatedOrderId[2];

    await this.setState({
      orderId: orderId,
      encodedOrderId: encodedOrderId,
      facilityType: facilityType
    });
    //console.log('encodedOrderId');
    //console.log(orderId + ' ' + encodedOrderId);


    let title = '';
    var shouldLoad = false;
    if (viewType === 'Inward Boxes') {
      title = 'Inward from innoviti';

      this.fetchBoxInwords(encodedOrderId);
      shouldLoad = true;
    } else if (viewType === 'Add Inventory') {
      title = 'Add/Verify inventory';
      shouldLoad = false;
    } else if (viewType === 'Fulfill Order') {
      title = 'Outward to SRO';
      this.fetchOrderDetails(encodedOrderId);
    } else if (viewType === 'Validate OTP') {
      title = 'Validate OTP';
      this.ResendOTP();
      this.setState({orderDetailOtpView: true});

    } else if (viewType === 'Verify Return Order') {
      title = 'Verify Return Order';
      this.setState({verifyORView: true});
      this.searchROInventoryDetails(encodedOrderId, facilityType);
    } else if (viewType === 'Prepare Return Order') {
      title = 'Prepare Return Order';
      this.setState({verifyORView: true});
      this.PROsearchROInventoryDetails(encodedOrderId, facilityType);
    } else if (viewType === 'Dispatch') {
      title = 'Dispatch';
      this.setState({verifyORView: true});
      this.DispatchDetails(encodedOrderId);
    } else if (viewType === 'Print DC') {
      this.getPDFDetails(encodedOrderId);
      return false;
    }


    this.setState({
      viewType: viewType,
      title: title,
      loading: shouldLoad
    })
  }

  fetchBoxInwords(encodedOrderId) {
    axios.get(config.get('API_URL') + '/inventory/box-inword?order_id=' + encodedOrderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      this.setState({
        inwordboxResponse: response.data,
      })
      this.setState({
        loading: false
      })

      if (response.data != null && response.data.length > 0) {
        this.setState({
          logistic: response.data[0].logistic,
          awb: response.data[0].awbNumber,
          challanNumber: response.data[0].ChallanNumber === null ? '' : response.data[0].ChallanNumber
        });
      } else {
        this.props.handleClick("tr", 2, 'Box details not found for order id ' + this.state.orderId);

      }
    }).catch(error => {
      console.log(error);
      this.setState({
        loading: false
      })
    });
  }

  handleInputBoxChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  BomhandleInputBoxChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  FOhandleInputBoxChange(e) {
    this.setState({
      FOScanSerialNo: e.target.value
    })
  }

  showTableView(e) {
    this.setState({
      viewType: 'tableView',
      title: 'Orders',
      BomScanEnterVerify:false,
    })
    this.refreshOrders();
    this.setState({
      logistic: '',
      awb: '',
      challanNumber: ''
    })
  }

  addInwardBox(e) {
    var inwordboxResponse = this.state.inwordboxResponse;
    var count = inwordboxResponse != null && inwordboxResponse.length > 0 ? inwordboxResponse[0].boxlist.length : 0;
    if (this.state.inwardBoxes.length < count) {
      this.setState({
        inwardBoxes: [...this.state.inwardBoxes, ""]
      })
    }
  }

  removeInwardBox(i, e) {
    e.preventDefault();
    let inwordBoxes = [...this.state.inwardBoxes];
    inwordBoxes.splice(i, 1);
    this.setState({
      inwardBoxes: inwordBoxes
    })
  }

  handleInwardBoxChange(i, e) {
    e.preventDefault();
    this.state.inwardBoxes[i] = e.target.value;
    this.setState({
      inwardBoxes: this.state.inwardBoxes
    })
  }

  submitInwardBoxDetails(e) {

    if (this.state.inwardBoxes[0] === "" || this.state.inwardBoxes.length === 0) {
      this.props.handleClick("tr", 3, "Enter Scanned Box Number.");
      return;
    }

    let orderId = this.state.encodedOrderId;
    let boxDetails = '';
    let delimeter = '';

    this.state.inwardBoxes.map((inwardBox, index) => {
      boxDetails = delimeter + boxDetails + inwardBox;
    });
    document.getElementById("idBoxInward").disabled = true;
    const data = JSON.stringify({
      orderId: orderId,
      boxDetails: boxDetails
    })

    if (boxDetails != '') {
      axios.post(config.get('API_URL') + '/inventory/box-inword',
        data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ` ${localStorage.usertoken}`,
            SalesforceToken: ` ${localStorage.salesforce_token}`
          }
        }).then(response => {

        var status = response.data.status;
        if (status === 'Failed') {

          document.getElementById("idBoxInward").disabled = false;
          // this.handleNotificationClick('tr', 3, response.data.message);
          this.props.handleClick("tr", 2, response.data.message);
        } else {
          this.props.handleClick("tr", 1, response.data.message);
          // this.handleNotificationClick('tr', 1, response.data.message);

          setTimeout(function () {
            window.location.href = "/admin/orders";
          }.bind(this), 5000);
        }
      }).catch(error => {
        console.log('Failed to update box');
        document.getElementById("idBoxInward").disabled = false;
        this.props.handleClick("tr", 3, 'Failed to update box details');
        //this.handleNotificationClick('tr', 3, 'Failed to update box details');
      });
    }

  }

  searchInventoryDetails(e) {
    this.setState({
      loading: true
    })
    if (this.state.boxSerialNumber === '') {
      this.props.handleClick("tr", 3, "Please enter box serial number");
      // this.handleNotificationClick('tr', 3, 'Please enter box serial number');
      return;
    }
    if ($.fn.DataTable.isDataTable('#inventoryTable')) {
      $('#inventoryTable').DataTable().destroy();
    }
    axios.get(config.get('API_URL') + '/inventory/box-details?order_id=' + this.state.encodedOrderId + '&box_detail=' + this.state.boxSerialNumber, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      console.log('Inventry');
      console.log(response);
      console.log(response.data[0].AssetDetails[0]);
      var diData = [];
      if (response.data[0].AssetDetails[0] !== undefined) {
        diData = response.data[0].AssetDetails[0].Detailslist.map(function (el) {
          var o = Object.assign({}, el);
          o.isScan = false;
          return o;
        });
      }

      this.setState({
        boxDetailResponse: response.data,
        loading: false,
        DisputAsset: diData
      })

      if (this.state.boxDetailResponse === null || this.state.boxDetailResponse.length === 0) {
        this.props.handleClick("tr", 3, 'Data not available for box serial number ' + this.state.boxSerialNumber);
        return;
      }

      var consumableDetails = this.state.boxDetailResponse[0].ConsumablesDetails;
      var assetDetails = this.state.boxDetailResponse[0].AssetDetails;
      if ((assetDetails === null || assetDetails.length === 0) && (consumableDetails === null || consumableDetails.length === 0)) {
        this.props.handleClick("tr", 3, 'Data not available for box serial number ' + this.state.boxSerialNumber);
        return;
      }

      this.setState({
        verifyInventoryView: true
      })
      var table = $('#inventoryTable').DataTable({
        searching: false, paging: false, info: false,
        "oLanguage": {
          "sEmptyTable": "There are no orders available"
        },
        "columnDefs": [
          {
            "width": "30",
            "targets": [4]
          },
          {
            "targets": [5],
            "visible": false
          },
          {
            "targets": [6],
            "visible": false
          },
          {
            "targets": [7],
            "visible": false
          },
          {
            "targets": [8],
            "visible": false
          }
        ]
      });
    }).catch(error => {
      console.log(error);
      this.props.handleClick("tr", 3, 'Failed to fetch data for box serial number ' + this.state.boxSerialNumber);
      this.setState({
        loading: false,
        verifyInventoryView: false
      })
    });
  }

  showSearchBoxSerialView(e) {
    this.setState({
      verifyInventoryView: false
    })
  }

  addProductSerialNumber(e) {

    if (this.state.productSerialNumber == '') {
      this.props.handleClick("tr", 3, 'Please enter product serial number');
      // this.handleNotificationClick('tr', 3, "Please enter product serial number");
      return;
    }

    var productSerialNumber = this.state.productSerialNumber;
    var vDisputAsset = this.state.DisputAsset;


    var foundSerialNumber = false;
    var table = $("#inventoryTable").DataTable();
    var rowLeanth = document.getElementById('inventoryTable').rows.length;


    let boxDetailResponse = this.state.boxDetailResponse;
    if (boxDetailResponse.length > 0 && boxDetailResponse[0].AssetDetails.length > 0) {

      for (var i = 0; i < rowLeanth; i++) {
        var tempData = table.cell({row: i, column: 8}).data();
        if (tempData === productSerialNumber) {
          foundSerialNumber = true;
          table.cell({row: i, column: 3}).data(productSerialNumber.toUpperCase());
          $('input[type="checkbox"]', table.row(i).nodes()).prop('checked', true);

          vDisputAsset.map(data => {
            if (data.AssetSerialNo === productSerialNumber) {
              data.isScan = true
            }
          });
        }
      }

      if (!foundSerialNumber) {
        this.props.handleClick("tr", 3, "Entered product serial number did not match");
        // this.handleNotificationClick('tr', 3, "Entered product serial number did not match");
        return;
      }

      this.setState({
        DisputAsset: vDisputAsset
      });


    }
  }

  createInventoryTableView(data, type, count) {
    return data.map((value, index) => {
      return (
        <tr key={count + 1 + index}>
          <td>
            {type === 'consumable' ?
              <input type="checkbox" value='true' disabled="disabled" checked="checked"/>
              : <input type="checkbox" disabled/>}
          </td>
          <td>{value.skuName}</td>
          <td>{value.skuDesc}</td>
          <td></td>
          <td>
            {type === 'consumable' ?
              <input type="text" name="quantity" value={value.quantity}
                     onChange={this.handleInputBoxChange.bind(this)}/>
              : '1'}

          </td>
          <td>{value.skuId}</td>
          <td>{value.BoxItemID}</td>
          <td>{type}</td>
          <td>{type === 'consumable' ?
            ''
            : value.AssetSerialNo}
          </td>

        </tr>
      )
    });
  }

  async submitInventoryDetails(e) {

    var table = $("#inventoryTable").DataTable();
    var data = table.rows().data();
    var skuDetails = [];
    var assetDetails = [];
    var consumableDetails = [];

    data.each(function (value, index) {
      var serialNo = table.cell({row: index, column: 3}).data();
      var type = table.cell({row: index, column: 7}).data();
      var sku = table.cell({row: index, column: 1}).data();
      var skuId = table.cell({row: index, column: 5}).data();
      var boxItemId = table.cell({row: index, column: 6}).data();

      if (type === 'asset') {
        if (serialNo === null || serialNo === '') {
          skuDetails.push(sku);
        }

        assetDetails.push({
          'skuid': skuId,
          'BoxItemID': boxItemId,
          'serialNo': serialNo
        });
      }

      if (type === 'consumable') {
        var quantity = $('input[type="text"]', table.row(index).nodes()).val();
        consumableDetails.push({
          'skuid': skuId,
          'BoxItemID': boxItemId,
          'quantity': quantity
        });
      }
    });

    if (skuDetails.length > 0) {
      this.props.handleClick("tr", 3, 'Missing serial number for SKUs ' + skuDetails);
      return;
    } else {
      const token = localStorage.usertoken;
      let warehouse_id = '';
      if (token != null) {
        const decoded = jwt_decode(token);
        warehouse_id = decoded.warehouse_id
      }

      const body = JSON.stringify({
        userid: warehouse_id,
        orderId: this.state.encodedOrderId,
        boxDetails: this.state.boxSerialNumber,
        assetDetails: assetDetails,
        consumableDetails: consumableDetails
      });

      document.getElementById("btnVerifysubmitInventory").disabled = true;

      await axios.post(config.get('API_URL') + '/inventory/box-details',
        body, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ` ${localStorage.usertoken}`,
            SalesforceToken: ` ${localStorage.salesforce_token}`
          }
        }).then(response => {

        var status = response.data.status;
        if (status === 'Success') {
          this.props.handleClick("tr", 1, response.data.message);
          // this.handleNotificationClick('tr', 1, response.data.message);
          setTimeout(function () {
            window.location.href = "/admin/orders";
          }.bind(this), 5000);
        } else {
          document.getElementById("btnVerifysubmitInventory").disabled = false;
          this.props.handleClick("tr", 3, response.data.message);
        }
      }).catch(error => {
        console.log('Failed to update box');
        console.log(error);
        document.getElementById("btnVerifysubmitInventory").disabled = false;
        this.props.handleClick("tr", 3, 'Failed to update box details');
      });
    }
  }

//end process

  fetchOrderDetails(encodedOrderId) {
    this.setState({
      loading: true
    })

    axios.get(config.get('API_URL') + '/inventory/order-details?order_id=' + encodedOrderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {

      //for Assest
      var FOTempAsset = [];
      response.data[0].AssetDetails[0].Detailslist.map(data => {
        var tempAsset = {
          AssetSerialNo: data.AssetSerialNo,
          BoxItemID: data.BoxItemID,
          quantity: data.quantity,
          skuDesc: data.skuDesc,
          skuId: data.skuId,
          skuName: data.skuName,
          type: data.type,
          ProcessQTY: 0,
          ScanedSerialNo: ''
        }

        FOTempAsset.push(tempAsset);
      })

//for ConsumablesDetails
      var FOTemp = [];
      response.data[0].ConsumablesDetails[0].Detailslist.map(data => {
        var temp = {
          quantity: data.quantity,
          disQty: '',
          skuDesc: data.skuDesc,
          skuId: data.skuId,
          skuName: data.skuName,
          type: "consumable"
        }

        FOTemp.push(temp);
      })

      this.setState({
        orderDetailResponse: response.data,
        orderDetailsTableData: [],
        FODisConsumable: FOTemp,
        FODisAssest: FOTempAsset
      });

      if (this.state.orderDetailResponse[0].AssetDetails[0].Detailslist.length < 1) {
        this.setState({
          HideShowScan: 'none'
        });
      }

      this.setState({
        loading: false
      });
      if (this.state.orderDetailResponse === null || this.state.orderDetailResponse.length === 0) {
        this.props.handleClick("tr", 3, 'Order details not available for order id ' + this.state.orderId);
        //this.handleNotificationClick('tr', 3, 'Order details not available for order id ' + this.state.orderId);
        return;
      }
      var consumableDetails = this.state.orderDetailResponse[0].ConsumablesDetails;
      var assetDetails = this.state.orderDetailResponse[0].AssetDetails;
      if ((assetDetails === null || assetDetails.length === 0) && (consumableDetails === null || consumableDetails.length === 0)) {
        this.props.handleClick("tr", 3, 'Order details not available for order id ' + this.state.orderId);
        // this.handleNotificationClick('tr', 3, 'Order details not available for order id ' + this.state.orderId);
        return;
      }

      if (consumableDetails.length > 0) {
        consumableDetails[0].Detailslist.map((item, index) => {
          item["type"] = "consumable";
          this.state.orderDetailsTableData.push(item);
        });
      }
      if (assetDetails.length > 0) {
        assetDetails[0].Detailslist.map((item, index) => {
          item["type"] = "asset";
          this.state.orderDetailsTableData.push(item);
        });
      }

      console.log(response.data);
    }).catch(error => {
      //console.log(error);
    });
  }

  addOrderDetailBody(data, type, count) {
    return data.map((value, index) => {
      return (
        <tr key={count + 1 + index}>
          <td>{value.skuName}</td>
          <td>{value.skuDesc}</td>
          <td>{value.quantity}</td>
          <td>
            {type === 'asset' ?
              <input type="text" name="idFOCountScanQTY" title={value.ScanedSerialNo} value={value.ProcessQTY}
                     disabled/>
              : <input type="text" name="FOConsumableEnterQTY" value={value.disQty}
                       onChange={this.handleOrderDetailSerialNo.bind(this, value, index)}/>}
          </td>
        </tr>
      )
    });
  }

  handleOrderDetailSerialNo(value, index, e) {
    //console.log('enter match');
    var tempConsumble = this.state.FODisConsumable;
    if (isNaN(e.target.value) == false) {

      tempConsumble.map(data => {
        if (data.skuId === value.skuId) {
          //console.log('match');
          if (e.target.value <= data.quantity) {
            //console.log('match2');
            data.disQty = e.target.value
          }
        }
      })

      this.setState({
        FODisConsumable: tempConsumble
      })

    }

    // alert(value.quantity +' :: '+e.target.value);

    // var serialNo = e.target.value;
    // this.setState({
    //     [e.target.name]: serialNo
    // });
    // value["textBoxSerialNumber"] = serialNo;
    // this.state.orderDetailsTableData[index] = value;
  }

  createOrderDetailsTableView() {

    let orderDetailResponse = this.state.orderDetailResponse;
    let assetDataDetails = [];
    let consumableDataDetails = [];

    if (orderDetailResponse.length > 0) {
      let assetDetails = orderDetailResponse[0].AssetDetails;
      if (assetDetails.length > 0) {
        assetDataDetails = this.addOrderDetailBody(this.state.FODisAssest, 'asset', 0);
      }

      let consumableDetails = orderDetailResponse[0].ConsumablesDetails;
      if (consumableDetails.length > 0) {
        consumableDataDetails = this.addOrderDetailBody(this.state.FODisConsumable, 'consumable', assetDataDetails.length);

      }
    }
    return [...consumableDataDetails, ...assetDataDetails];
  }

  FOOnScanClick() {

    //console.log(this.state.FODisAssest);
    let foScanSerial = this.state.FOScanSerialNo;

    if (this.state.FOScanSerialNo == '') {
      this.props.handleClick("tr", 3, 'Enter Serial Number');
      return false;
    }

    var tempDisAsset = this.state.FODisAssest;
    let vMatch = false;

    tempDisAsset.map((data, index) => {
      let innerAssetSerial = data.AssetSerialNo;
      var innerMatch = false;

      for (var i = 0; i < innerAssetSerial.length; i++) {
        if (innerAssetSerial[i] === foScanSerial) {
          if (data.ProcessQTY < data.quantity) {
            innerMatch = true;
            vMatch = true;
            var vAsset = {
              skuid: data.skuId,
              serialNo: foScanSerial
            }
            var vtAsset = this.state.FOTempAssest;
            vtAsset.push(vAsset);
            innerAssetSerial.splice(i, 1);
            this.setState({
              FOTempAssest: vtAsset
            });
          }
        }
      }

      if (innerMatch == true) {
        data.ProcessQTY = data.ProcessQTY + 1;
        if (data.ScanedSerialNo === '') {
          data.ScanedSerialNo = foScanSerial;
        } else {
          data.ScanedSerialNo = data.ScanedSerialNo + ', ' + foScanSerial;
        }
      }
    });

    if (vMatch === false) {
      this.props.handleClick("tr", 3, 'Enter Valid Serial Number');
    } else {

      this.setState({
        FOScanSerialNo: '',
        FODisAssest: tempDisAsset
      });
    }
  }

  async submitOrderDetails(e) {

    //for Consumable Validation
    var ConsumMatch = true;
    var ConsumMatchSKU = '';
    let vtConsum = this.state.FODisConsumable;

    vtConsum.map((data, index) => {
      var disQuantity = parseInt(data.disQty);
      if (disQuantity < data.quantity) {
        ConsumMatch = false;
        ConsumMatchSKU = data.skuName;
      }
    });

    if (ConsumMatch == false) {
      this.props.handleClick("tr", 3, 'Missing Quantity for SKUs: ' + ConsumMatchSKU);
      return false;
    }

    //For Asset Validation
    var AssetMatch = true;
    var AssetMatchSKU = '';
    let vtAsset = this.state.FODisAssest;
    vtAsset.map((data, index) => {
      if (data.ProcessQTY < data.quantity) {
        AssetMatch = false;
        AssetMatchSKU = data.skuName;
      }
    });

    if (AssetMatch == false) {
      this.props.handleClick("tr", 3, 'Missing serial number for SKUs: ' + AssetMatchSKU);
      return false;
    }

    document.getElementById("btnFOSubmitt").disabled = true;

    // this.setState({
    //     orderDetailOtpView: true
    //
    // })

    //Make Data for Cosumable
    var ConsumFinalArray = [];
    vtConsum.map((data, index) => {
      var ConsumeData = {
        skuid: data.skuId,
        quantity: data.quantity
      }
      ConsumFinalArray.push(ConsumeData);
    });

    //Make data for Asset

    var AssetFinalArray = this.state.FOTempAssest;

    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }

    const body = {
      userid: warehouse_id,
      orderId: this.state.encodedOrderId,
      assetDetails: AssetFinalArray,
      consumableDetails: ConsumFinalArray
    }

    //console.log('body');
    //console.log(body);

    await axios.post(config.get('API_URL') + '/inventory/order-details',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      var status = response.status;
      if (status === 200) {
        this.setState({
          orderDetailOtpView: true
        })
      }
      this.props.handleClick("tr", 1, response.data.message);
    }).catch(error => {
      document.getElementById("btnFOSubmitt").disabled = false;
      //console.log('Failed to update box');
      this.props.handleClick("tr", 3, 'Failed to update box details');
    });
  }

  async validateOtp() {
    //console.log("Validating OTP");
    if (this.state.otpValue === null || this.state.otpValue === '') {
      this.props.handleClick("tr", 3, "Please enter otp.");
      // this.handleNotificationClick('tr', 3, 'Please enter otp');
      return;
    }
    const body = JSON.stringify({
      otp: this.state.otpValue,
      orderId: this.state.orderId
    });
    await axios.post(config.get('API_URL') + '/inventory/validate-otp',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      var status = response.status;
      if (status === 200 && response.data.message.includes('successfully')) {

        this.getPDFDetails(this.state.encodedOrderId);

        // this.refreshOrders();
        // this.setState({
        //     orderDetailOtpView: false,
        //     viewType: 'tableView'
        // });

        setTimeout(function () {
          window.location.href = "/admin/orders";
        }.bind(this), 5000);

      }
      this.props.handleClick("tr", 1, response.data.message);
      // this.handleNotificationClick('tr', 1, response.data.message);
    }).catch(error => {
      //console.log(error);
      this.props.handleClick("tr", 3, 'OTP validate failed');
      // this.handleNotificationClick('tr', 3, 'OTP validate failed');
    });
  }

  handleOtpInput(e) {
    const pattern = /^[0-9\b]+$/;
    //console.log(pattern.test(e.target.value));
    if (e.target.value === '' || pattern.test(e.target.value)) {
      this.setState({
        otpValue: e.target.value,
      });
    }
  }

  async refreshOrders() {
    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }
    // if ($.fn.DataTable.isDataTable('#ordersTable')) {
    //     $('#ordersTable').DataTable().destroy();
    // }
    await axios.get(config.get('API_URL') + '/inventory/orders?user_id=' + warehouse_id, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      //console.log('order');
      //console.log(response);
      var tempExcelData = [];
      response.data.map((value, index) => {

        let createdDate = new Date(value.CreatedDate).toJSON().slice(0, 19).replace('T', ' ');
        let action = value.Action_WH__c;
        let concatOrderId = value.Id + ',' + value.Name + ',' + value.Fullfield_By__r.Facility_Type__c;
        let isLink = false;
        if (action != null) {
          if (action.includes('Add Inventory')) {
            action = 'Add Inventory';
          } else if (action.includes('Fulfill Order')) {
            action = 'Fulfill Order';
          } else if (action.includes('Inward Boxes')) {
            action = 'Inward Boxes';
          } else if (action.includes('Validate OTP')) {
            action = 'Validate OTP';
          } else if (action.includes('Verify Return Order')) {
            action = 'Verify Return Order';
          } else if (action.includes('Prepare Return Order')) {
            action = 'Prepare Return Order';
          } else if (action.includes('Dispatch')) {
            action = 'Dispatch';
          } else if (action.includes('NA')) {
            if (value.Actions__c === "No Open Orders" && value.Order_Status__c === "Closed") {
              action = 'Print DC';
            }
          }
        }
        let awb = value.AWB_Number__c;

        var tempData = {
          OrderId: value.Name,
          OrderType: value.Order_Type__c,
          CreatedDate: moment(createdDate).format('DD-MM-YYYY'),
          OrderStatus: value.Order_Status__c,
          OrderedQuantity: value.Ordered_Quantity__c,
          PendingQuantity: value.Pending_Quantity__c,
          Actions: action,
          ReturnAction: value.Return_Action__c,
          AWBNumber: awb == undefined ? '' : awb
        }
        tempExcelData.push(tempData);
      });

      this.setState({
        order_response: response.data,
        ExcelData: tempExcelData
      });
      var table = $('#ordersTable').DataTable({
        "oLanguage": {
          "sEmptyTable": "There are no orders available"
        },
        "order": [[0, "desc"]]

      });

      this.setState({
        loading: false
      })
    });
  }

  handleSelectTab(key, e) {

  }

  //on click verify Return order searching for inven
  searchROInventoryDetails(orderId, FacilityType) {
    this.setState({
      emptyRO:false
    }) 
    this._appendLoaderToBody();
    if ($.fn.DataTable.isDataTable('#ROTable')) {
      $('#ROTable').DataTable().destroy();
    }
    
    axios.get(config.get('API_URL') + '/inventory/returnOrder?order_id=' + orderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {

      //if the response in null means when no Return orders found against any Return Order
      if (response.data.Boxid ===null) {
        this.props.handleClick("tr", 2, 'Data not available for order number ' + this.state.encodedOrderId);
        //this.handleNotificationClick('tr', 3, 'Data not available for order number ' + this.state.encodedOrderId);
        return;

      }else{
        //console.log('order details');
        //console.log(response);
        var mainData = [];
        var pendingData = [];
        if (response.data.length > 0) {
          var OrderItem = response.data[0].OrderItem;

          OrderItem.map((data) => {
            if (data.SkuType === 'Asset') {
              var tempMain = {
                Type: 'Asset',
                SKU: data.SkuName,
                ItemName: data.SkuDescription,
                PackedQTY: data.PackedQuantity,
                ProcessedQTY: 0,
                ItemId: data.ItemId,
                SkuId: data.SkuID,
                AssetId: '',
                mPackedQTY: data.PackedQuantity,
                mUnpackedQTY: data.UnpackedQuantity,
                mDamageQTY: data.DamageQuantity,
                Serial: ''
              }

              var tempPendingData = data.AssetList;
              tempPendingData.map((listData) => {
                var tempPeding = {
                  Type: 'Asset',
                  SKU: data.SkuName,
                  Serial: listData.SerialNo,
                  assetSerialNumber:listData.assetSerialNumber,
                  ItemName: listData.Description,
                  PackedQTY: 1,
                  ProcessedQTY: 0,
                  DisQTY: 1,
                  ItemId: data.ItemId,
                  SkuId: data.SkuID,
                  AssetId: listData.AssetId,
                  mPackedQTY: data.PackedQuantity,
                  mUnpackedQTY: data.UnpackedQuantity,
                  mDamageQTY: data.DamageQuantity
                }
                pendingData.push(tempPeding);
              });
              mainData.push(tempMain);
            } else if (data.SkuType === 'Consumable') {
              var tempMain = {
                Type: 'Consumable',
                SKU: data.SkuName,
                ItemName: data.SkuDescription,
                PackedQTY: data.PackedQuantity,
                ProcessedQTY: 0,
                ItemId: data.ItemId,
                SkuId: data.SkuID,
                mPackedQTY: data.PackedQuantity,
                mUnpackedQTY: data.UnpackedQuantity,
                mDamageQTY: data.DamageQuantity,
                Serial: ''
              }

              var tempPeding = {
                Type: 'Consumable',
                SKU: data.SkuName,
                Serial: '',
                ItemName: data.SkuDescription,
                PackedQTY: data.PackedQuantity,
                ProcessedQTY: 0,
                DisQTY: data.PackedQuantity,
                ItemId: data.ItemId,
                SkuId: data.SkuID,
                mPackedQTY: data.PackedQuantity,
                mUnpackedQTY: data.UnpackedQuantity,
                mDamageQTY: data.DamageQuantity
              }

              mainData.push(tempMain);
              pendingData.push(tempPeding);
            } else if (data.SkuType === 'ISKU') {
              var tempMain = {
                Type: 'BOM',
                SKU: data.SkuName,
                ItemName: data.SkuDescription,
                PackedQTY: data.PackedQuantity,
                ProcessedQTY: 0,
                ItemId: data.ItemId,
                SkuId: data.SkuID,
                AssetId: '',
                mPackedQTY: data.PackedQuantity,
                mUnpackedQTY: data.UnpackedQuantity,
                mDamageQTY: data.DamageQuantity,
                Serial: ''
              }

              var tempPendingData = data.AssetList;
              tempPendingData.map((listData) => {
                var tempPeding = {
                  Type: 'Asset',
                  SKU: data.SkuName,
                  Serial: listData.SerialNo,
                  assetSerialNumber:listData.assetSerialNumber,
                  ItemName: listData.Description,
                  PackedQTY: 1,
                  ProcessedQTY: 0,
                  DisQTY: 1,
                  ItemId: data.ItemId,
                  SkuId: data.SkuID,
                  AssetId: listData.AssetId,
                  mPackedQTY: data.PackedQuantity,
                  mUnpackedQTY: data.UnpackedQuantity,
                  mDamageQTY: data.DamageQuantity
                }
                pendingData.push(tempPeding);
              });
              mainData.push(tempMain);
            }
          });

          this.setState({
            orderReturnData: mainData,
            ROPending: pendingData,
            ROBoxNumber: response.data[0].BoxNumber,
            ROBoxid: response.data[0].Boxid,
            ROOrderID: response.data[0].OrderID,
            ROOrderStatus: response.data[0].OrderStatus,
            ROOrderType: response.data[0].OrderType,
            // AssetSKU: response.data[0].OrderItem[0].SkuName,
          });

        }

        //console.log('SKU Name');
        //console.log(response.data[0].OrderItem[0].SkuName);

        // if (this.state.orderReturnData === null || this.state.orderReturnData.length === 0) {
        //   this.props.handleClick("tr", 2, 'Data not available for order number ' + this.state.encodedOrderId);
        //   //this.handleNotificationClick('tr', 3, 'Data not available for order number ' + this.state.encodedOrderId);
        //   return;
        // }
        this.setState({
          verifyROView: true,
        });

           
        if(response.data[0].OrderItem[0].skuSubType == 'BOM'){
          
          this._autoScanAnyAssetNumber(response.data[0].OrderItem[0].AssetList[0].SerialNo);
        
        }else{
          const ts = response.data[0].OrderItem.filter((items)=>items.skuSubType=='Terminal')
          console.log('fileterd',ts)
          //now apply with the BOm Details-
          console.log(ts[0].AssetList[0].SerialNo) 
          this._autoScanAnyAssetNumber(ts[0].AssetList[0].SerialNo)   
        }
        
      }

    }).catch(error => {
      //console.log(error);
      this.props.handleClick("tr", 3, 'Failed to fetch data for box serial number ' + this.state.boxSerialNumber);
      // this.handleNotificationClick('tr', 3, 'Failed to fetch data for box serial number ' + this.state.boxSerialNumber);
      this.setState({
        loading: false,
        verifyROView: false
      })
    });
  }



  //auto scan the first asset no
  _autoScanAnyAssetNumber(skuName){
    
    //Scanning the BOM details
    this.BOMtoggleShowHide(skuName);
  }

  //scaning BOM details by Asset number
  async BOMtoggleShowHide(BomorderId) {
    //document.getElementById("BomROSubmitOne").disabled = true;

    await axios.get(config.get('API_URL') + '/inventory/getBOMDetails?order_id=' + BomorderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      //console.log('BOM Data');
      // console.log(response)

      var mainData = [];
      var pendingData = [];
      if (response.data.length > 0) {
        var OrderItem = response.data;

        //console.log('OrderItem');
        //console.log(OrderItem);

        //console.log('Order Data');
        //console.log(OrderItem[0].SKU__r.Description__c);

        OrderItem.map((data) => {
          if (data.SKU_Type__c === 'Asset') {
            var tempMain = {
              Type: 'Asset',
              SKU: data.SKU__r.Name,
              ItemName: data.SKU__r.Description__c,
              PackedQTY: data.Quantity__c,
              ProcessedQTY: 0,
              ItemId: data.Id,
              SkuId: data.SKU__r.Id,
              AssetId: '',
              mPackedQTY: data.Quantity__c,
              mUnpackedQTY: 0,
              mDamageQTY: 0,
              Serial: data.Asset_Serial_No__c
            }

            var tempPeding = {
              Type: 'Asset',
              SKU: data.SKU__r.Name,
              Serial: data.Asset_Serial_No__c,
              ItemName: data.SKU__r.Description__c,
              PackedQTY: 1,
              ProcessedQTY: 0,
              DisQTY: 1,
              ItemId: data.Id,
              SkuId: data.SKU__r.Id,
              AssetId: data.AssetID__c,
              mPackedQTY: 1,
              mUnpackedQTY: 0,
              mDamageQTY: 0
            }
            pendingData.push(tempPeding);

            mainData.push(tempMain);
          } else if (data.SKU_Type__c === 'Consumable') {
            var tempMain = {
              Type: 'Consumable',
              SKU: data.SKU__r.Name,
              ItemName: data.SKU__r.Description__c,
              PackedQTY: data.Quantity__c,
              ProcessedQTY: 0,
              ItemId: data.Id,
              SkuId: data.SKU__r.Id,
              mPackedQTY: data.Quantity__c,
              mUnpackedQTY: 0,
              mDamageQTY: 0,
              Serial: ''
            }

            var tempPeding = {
              Type: 'Consumable',
              SKU: data.SKU__r.Name,
              Serial: '',
              ItemName: data.SKU__r.Description__c,
              PackedQTY: data.Quantity__c,
              ProcessedQTY: 0,
              DisQTY: data.Quantity__c,
              ItemId: data.Id,
              SkuId: data.SKU__r.Id,
              mPackedQTY: data.Quantity__c,
              mUnpackedQTY: 0,
              mDamageQTY: 0
            }

            mainData.push(tempMain);
            pendingData.push(tempPeding);
          }

        });

        //console.log('main data');
        //console.log(mainData);

        this.setState({
          BomorderReturnData: mainData,
          BomROPending: pendingData,
          BomROBoxNumber: response.data[0].BoxNumber,
          BomROBoxid: response.data[0].Boxid,
          BomROOrderID: response.data[0].OrderID,
          BomROOrderStatus: response.data[0].OrderStatus,
          BomROOrderType: response.data[0].OrderType,
        });

      }else{
        this.setState({
          emptyRO:true
        })
        //TODO add a condition to check BOM if its a bom we need to show different Notification
        this.props.handleClick("tr", 2, `No return order items found for this BOM ${BomorderId}`);
      }

    })

    this.setState({
      // BomModal: !this.state.BomModal,
      loader:'none',
    })
  }


  //creating loader element and appending it to body child
  _appendLoaderToBody(){
    var loader = document.getElementById("loaderId");
    document.body.appendChild(loader);
    this.setState({
      loader:'',
    });
  }

  //Scaning asset number from verify Input field
  onROScanClick() {
    //console.log('Verify return order');
    //console.log(this.state.ROPending);
    let tempPendingList = this.state.ROPending;
    var proId = this.state.productSerialNumber;
    proId = proId.toUpperCase();
    var filterArray = tempPendingList.filter(function (el) {
      return el.Serial == proId;
    });


    if (filterArray.length < 1) {
      this.props.handleClick("tr", 3, 'Enter Valid Serial Number');
      return;
    } else {
      this.setState({ScanEnterVerify: true});
    }
    var BomAssetId = '';

    var tempROScanData = this.state.ROScanData;
    filterArray.map((data) => {
      var tempScanData = {
        Serial: data.Serial,
        SKU: data.SKU,
        AssetId: data.AssetId
      }
      BomAssetId = data.AssetId;
      tempROScanData.push(tempScanData);
    });


    this.setState({
      ROScanData: tempROScanData,
      BomAssetId: BomAssetId
    });

    var lblSKU = filterArray[0].SKU;
    var temporderReturnData = this.state.orderReturnData;
    temporderReturnData.map((data) => {
      if (data.Type == 'Asset' && data.SKU == lblSKU) {
        data.ProcessedQTY = data.ProcessedQTY + 1;
      } else if (data.Type == 'BOM' && data.SKU == lblSKU) {
        data.ProcessedQTY = data.ProcessedQTY + 1;


        //calling the get Bom details API
        //console.log("Calling get BOM");
        //console.log(filterArray[0].Serial);
        this.BOMtoggleShowHide(filterArray[0].Serial);

      }
    });

    if (tempPendingList.length > 0) {
      const tempPendingList2 = tempPendingList.filter(item => item.Serial !== proId);
      this.props.handleClick("tr", 1, 'Scan Successfully: ' + proId);
      // this.handleNotificationClick('tr', 1, 'Scan Successfully: '+proId);
      this.setState({
        orderReturnData: temporderReturnData,
        ROPending: tempPendingList2,

      });

    }
  }

  onROTxtChange(e) {

    var skuId = e.target.id;
    var cngValue = 0;
    if (e.target.value !== '') {
      cngValue = parseInt(e.target.value);
    }

    var tempOrder = this.state.orderReturnData;
    tempOrder.map((data) => {
      if (data.SKU === skuId && data.Type === 'Consumable') {
        if (cngValue <= parseInt(data.PackedQTY)) {
          data.ProcessedQTY = cngValue;
        } else {
          this.props.handleClick("tr", 2, "Enter valid process quantity");
          // this.handleNotificationClick('tr', 3, 'Enter valid process quantity');
          return;
        }
      }
    });

    this.setState({
      orderReturnData: tempOrder
    });

    var tempPendingData = this.state.ROPending;
    tempPendingData.map((data) => {
      if (data.SKU === skuId && data.Type === 'Consumable') {
        if (cngValue <= parseInt(data.PackedQTY)) {
          data.DisQTY = data.PackedQTY - cngValue;
        }
      }
    });

    this.setState({
      ROPending: tempPendingData,
      ScanEnterVerify: true
    });

  }

  async onROScanSubmin() {

    if (this.state.BomScanEnterVerify == false) {
      this.props.handleClick("tr", 3, "Scan or enter processed quantity.");
      // this.handleNotificationClick('tr', 3, 'Scan or enter processed quantity');
      return;
    }

    this.setState({
      viewType: 'RO Validate OTP'
    });

    // document.getElementById("ROSubmitOne").disabled = true;
    // document.getElementById("ROSubmitTwo").disabled = true;


    var tempBoxId = this.state.ROBoxid;
    const data = {
      boxId: tempBoxId
    }
    //console.log('sending OTP');
    await axios.post(config.get('API_URL') + '/inventory/ROsend_otp', data, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      },

    }).then(response => {
      if (response.data.message !== '') {
        this.setState({
          ROOTP: response.data.sentOtp,
          viewType: 'RO Validate OTP'
        })
        this.props.handleClick("tr", 1, response.data.message);
        // this.handleNotificationClick('tr', 1, response.data.message);
      } else {
        this.props.handleClick("tr", 3, 'Error during send OTP.');
        // this.handleNotificationClick('tr', 3, 'Error during send OTP.');
        return;
      }
      //console.log(response.data);
    })
      .catch((err) => {
        this.props.handleClick("tr", 3, 'Error during send OTP.');
        //  this.handleNotificationClick('tr', 3, 'Error during send OTP.');
        return;
      });
  }

  async _secondCallTOReturnOrder(){
    document.getElementById("roValidateOTP").disabled = true;

    var ScanAssetDetails = [];
    this.state.ROScanData.map((data) => {
      var ScanAssetDetailsItem = {
        SerialNo: data.Serial,
        AssetId: data.AssetId
      }
      ScanAssetDetails.push(ScanAssetDetailsItem);
    });

    var UnScanAssetDetails = [];
    this.state.ROPending.map((data) => {
      if (data.Type === 'Asset') {
        var UnScanAssetDetailsItem = {
          SerialNo: data.Serial,
          AssetId: data.AssetId
        }
        UnScanAssetDetails.push(UnScanAssetDetailsItem);
      }
    });

    var tempitemDetails = [];
    this.state.orderReturnData.map((data) => {
      var itemDetails = {
        ItemId: data.ItemId,
        OrderedQuantity: data.PackedQTY,
        SentQuantity: data.mUnpackedQTY,
        ReceivedQuantity: data.mUnpackedQTY,
        DamagedQuantity: data.mDamageQTY,
        SKUId: data.SkuId,
        Description: data.ItemName,
        SKUType: data.Type,
        AskedQuantity: data.PackedQTY - data.mUnpackedQTY,
        ProcessedQuantity: data.ProcessedQTY,
        Status: true
      }
      tempitemDetails.push(itemDetails);
    });

    //BOM Data Set
    var BomDetails = [];
    this.state.BomROScanData.map(data => {
      var TempData = {
        BomSerial: data.BOMSerial,
        SKUId: data.SkuId,
        SKU: data.SKU,
        AssetId: data.AssetId,
        AssetName: data.Serial,
        Quantity: 1
      }
      BomDetails.push(TempData);
    });

    this.state.BomorderReturnData.map(data => {
      if (data.Type == 'Consumable') {
        var TempData = {
          BomSerial: data.Serial,
          SKUId: data.SkuId,
          SKU: data.SKU,
          AssetId: data.AssetId,
          AssetName: '',
          Quantity: data.ProcessedQTY
        }
        BomDetails.push(TempData);
      }
    })
    //End BOM Data set

    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }

    var SetRecord = {
      userid: warehouse_id,
      orderId: this.state.ROOrderID,
      BoxId: this.state.ROBoxid,
      requesttype: 'RO2',
      ScanAssetDetails: ScanAssetDetails,
      UnScanAssetDetails: UnScanAssetDetails,
      itemDetails: tempitemDetails,
      BOMDetails: BomDetails
    }
    //console.log('Bom Submit');
    //console.log(SetRecord);


    await axios.post(config.get('API_URL') + '/inventory/ROReturnOrder', SetRecord, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      },
    }).then(response => {
      this.props.handleClick("tr", 1, response.data.message);
      //this.handleNotificationClick('tr', 1, response.data.message);
      // this.setState({
      //     viewType: 'tableView',
      //     title: 'Orders'
      // });
      setTimeout(function () {
        window.location.href = "/admin/orders";
      }.bind(this), 5000);
    })
      .catch((err) => {
        //console.log('Error');
        //console.log(err);
      });

    //  this.goBackOnOrder();
    setTimeout(function () {
      window.location.href = "/admin/orders";
    }.bind(this), 5000);
  }

  async validateAndSubmintData() {

//     var SentOTP = this.state.ROOTP;
//     var enterOTP = this.state.otpValue;

//     if (SentOTP !== enterOTP) {
//       this.props.handleClick("tr", 3, 'Enter valid OTP.');
//       //this.handleNotificationClick('tr', 3, 'Enter valid OTP.');
//       return;
//     }

    const body = JSON.stringify({
      otp: this.state.otpValue,
      orderId: this.state.orderId
    });
    await axios.post(config.get('API_URL') + '/inventory/validate-otp',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {
      // var status = response.status;
      if (response.data.message.includes('successfully')) {
        console.log('success Case')
        this._secondCallTOReturnOrder()
        this.props.handleClick("tr", 1, response.data.message);
        
        setTimeout(function () {
          window.location.href = "/admin/orders";
        }.bind(this), 5000);
      
      }else{
        console.log('else Case')
        this.props.handleClick("tr", 3, response.data.message);
      }
      // this.handleNotificationClick('tr', 1, response.data.message);
    }).catch(error => {
      console.log(error);
      this.props.handleClick("tr", 3, 'OTP validate failed');
      // this.handleNotificationClick('tr', 3, 'OTP validate failed');
    });

    console.log('continue...')

  }

  BomonROScanClick() {


    let tempPendingList = this.state.BomROPending;
    var proId = this.state.BomproductSerialNumber;
    proId = proId.toUpperCase();
    var filterArray = tempPendingList.filter(function (el) {
      return el.Serial == proId;
    });


    if (filterArray.length < 1) {
      this.props.handleClick("tr", 2, 'Serial does not match! Please try again');
      return;
    }

    var tempROScanData = this.state.BomROScanData;
    filterArray.map((data) => {
      var tempScanData = {
        BOMSerial: this.state.BomAssetId,
        Serial: data.Serial,
        SKU: data.SKU,
        SkuId: data.SkuId,
        AssetName: data.ItemName,
        AssetId: data.AssetId
      }
      tempROScanData.push(tempScanData);
    })

    this.setState({
      BomROScanData: tempROScanData,
    });

    var lblSKU = filterArray[0].Serial;
    var temporderReturnData = this.state.BomorderReturnData;

    temporderReturnData.map((data) => {
      if (data.Type == 'Asset' && data.Serial == lblSKU) {
        data.ProcessedQTY = data.ProcessedQTY + 1;
      }
    });

    if (tempPendingList.length > 0) {
      const tempPendingList2 = tempPendingList.filter(item => item.Serial !== proId);
      this.props.handleClick("tr", 1, 'Scan Successfully: ' + proId);
      // this.handleNotificationClick('tr', 1, 'Scan Successfully: '+proId);
      document.getElementById("serialDataInput").value='';
      this.setState({
        BomorderReturnData: temporderReturnData,
        BomROPending: tempPendingList2,
        BomScanEnterVerify: true
      });
    }
  }

  BomonROTxtChange(e) {

    var skuId = e.target.id;
    var cngValue = 0;
    if (e.target.value !== '') {
      cngValue = parseInt(e.target.value);
    }

    var tempOrder = this.state.BomorderReturnData;
    tempOrder.map((data) => {
      if (data.SKU === skuId && data.Type === 'Consumable') {
        if (cngValue <= parseInt(data.PackedQTY)) {
          data.ProcessedQTY = cngValue;
          data.Serial = this.state.BomAssetId;
        } else {
          this.props.handleClick("tr", 2, "Enter valid process quantity");
          // this.handleNotificationClick('tr', 3, 'Enter valid process quantity');
          return;
        }
      }
    });

    this.setState({
      BomorderReturnData: tempOrder
    });

    var tempPendingData = this.state.BomROPending;
    tempPendingData.map((data) => {
      if (data.SKU === skuId && data.Type === 'Consumable') {
        if (cngValue <= parseInt(data.PackedQTY)) {
          data.DisQTY = data.PackedQTY - cngValue;
        }
      }
    });

    this.setState({
      BomROPending: tempPendingData,
      BomScanEnterVerify: true
    });

  }

  BomonROScanSubmin() {

    let ScanQty = this.state.BomROScanData.length;
    let OrdQty = this.state.BomorderReturnData.length;

    // if(ScanQty !== OrdQty) {
    //     alert('Scan or enter processed quantity.');
    //     return false;
    // }

    // document.getElementById("BomROSubmitOne").disabled = true;

    this.setState({
      BomModal: !this.state.BomModal,
    })


  }


  PROsearchROInventoryDetails(orderId, userId) {

    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }

    if ($.fn.DataTable.isDataTable('#PROTable')) {
      $('#PROTable').DataTable().destroy();
    }

    axios.get(config.get('API_URL') + '/inventory/prepareReturnOrder?order_id=' + orderId + '&user_id=' + warehouse_id, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      //console.log('PRO');
      //console.log(response.data);

      var mainData = [];
      var pendingData = [];
      if (response.data.length > 0) {
        var OrderItem = response.data[0].OrderItem;
        OrderItem.map((data) => {
          if (data.SkuType === 'Asset') {
            var tempMain = {
              Type: 'Asset',
              SKU: data.SkuName,
              ItemName: data.SkuDescription,
              PackedQTY: data.PackedQuantity,
              ProcessedQTY: 0,
              ItemId: data.ItemId,
              SkuId: data.SkuID,
              AssetId: '',
              mPackedQTY: data.PackedQuantity,
              mUnpackedQTY: data.UnpackedQuantity,
              mDamageQTY: data.DamageQuantity,
              Serial: ''
            }

            var tempPendingData = data.AssetList;
            tempPendingData.map((listData) => {
              var tempPeding = {
                Type: 'Asset',
                SKU: data.SkuName,
                Serial: listData.SerialNo,
                ItemName: listData.Description,
                PackedQTY: 1,
                ProcessedQTY: 0,
                DisQTY: 1,
                ItemId: data.ItemId,
                SkuId: data.SkuID,
                AssetId: listData.AssetId,
                mPackedQTY: data.PackedQuantity,
                mUnpackedQTY: data.UnpackedQuantity,
                mDamageQTY: data.DamageQuantity
              }
              pendingData.push(tempPeding);
            });
            mainData.push(tempMain);
          } else if (data.SkuType === 'Consumable') {
            var tempMain = {
              Type: 'Consumable',
              SKU: data.SkuName,
              ItemName: data.SkuDescription,
              PackedQTY: data.PackedQuantity,
              ProcessedQTY: 0,
              ItemId: data.ItemId,
              SkuId: data.SkuID,
              mPackedQTY: data.PackedQuantity,
              mUnpackedQTY: data.UnpackedQuantity,
              mDamageQTY: data.DamageQuantity,
              Serial: ''
            }

            var tempPeding = {
              Type: 'Consumable',
              SKU: data.SkuName,
              Serial: '',
              ItemName: data.SkuDescription,
              PackedQTY: data.PackedQuantity,
              ProcessedQTY: 0,
              DisQTY: data.PackedQuantity,
              ItemId: data.ItemId,
              SkuId: data.SkuID,
              mPackedQTY: data.PackedQuantity,
              mUnpackedQTY: data.UnpackedQuantity,
              mDamageQTY: data.DamageQuantity
            }

            mainData.push(tempMain);
            pendingData.push(tempPeding);
          }
        });

        this.setState({
          PROorderReturnData: mainData,
          PROPending: pendingData,
          PROBoxNumber: response.data[0].BoxNumber,
          PROBoxid: response.data[0].Boxid,
          PROOrderID: response.data[0].OrderID,
          PROOrderStatus: response.data[0].OrderStatus,
          PROOrderType: response.data[0].OrderType,
          PRORequestType: response.data[0].requesttype
        });

      }

      if (this.state.PROorderReturnData === null || this.state.PROorderReturnData.length === 0) {
        this.props.handleClick("tr", 3, 'Data not available for order number ' + this.state.encodedOrderId);
        // this.handleNotificationClick('tr', 3, 'Data not available for order number ' + this.state.encodedOrderId);
        return;
      }
      this.setState({
        verifyROView: true
      });

    }).catch(error => {
      //console.log(error.response);
      this.props.handleClick("tr", 3, 'Failed to fetch data for box serial number ' + this.state.boxSerialNumber);
      //this.handleNotificationClick('tr', 3, 'Failed to fetch data for box serial number ' + this.state.boxSerialNumber);
      this.setState({
        loading: false,
        verifyROView: false
      })
    });
  }

  onPROScanClick() {

    let tempPendingList = this.state.PROPending;
    //console.log('tempPendingList');
    //console.log(tempPendingList);

    var proId = this.state.productSerialNumber;
    proId = proId.toUpperCase();
    var filterArray = tempPendingList.filter(function (el) {
      return el.Serial == proId;
    });

    if (filterArray.length < 1) {
      this.props.handleClick("tr", 3, 'Invalid serial no: ' + proId);
      return;
    }

    var lblSKU = filterArray[0].SKU;
    var temporderReturnData = this.state.PROorderReturnData;


    temporderReturnData.map((data) => {
      if (data.Type == 'Asset' && data.SKU == lblSKU && data.ProcessedQTY < data.PackedQTY) {
        data.ProcessedQTY = data.ProcessedQTY + 1;
        this.props.handleClick("tr", 1, 'Scan Successfully: ' + proId);

        var tempROScanData = this.state.PROScanData;
        filterArray.map((data) => {
          var tempScanData = {
            Serial: data.Serial,
            SKU: data.SKU,
            AssetId: data.AssetId
          }
          tempROScanData.push(tempScanData);
        })

        const tempPendingList2 = tempPendingList.filter(item => item.Serial !== proId);

        this.setState({
          PROScanData: tempROScanData,
          PROPending: tempPendingList2,
        });
      } else {
        if (data.Type == 'Asset' && data.SKU == lblSKU && filterArray.length > 0) {
          this.props.handleClick("tr", 2, 'Processed QTY is equal to Asked QTY');
        }
      }
    });

    if (tempPendingList.length > 0) {

      //this.handleNotificationClick('tr', 1, 'Scan Successfully: '+proId);
      this.setState({
        PROorderReturnData: temporderReturnData,
        PROScanEnterVerify: true
      });
    }
  }

  onPROTxtChange(e) {

    var skuId = e.target.id;
    var cngValue = 0;
    if (e.target.value !== '') {
      cngValue = parseInt(e.target.value);
    }

    var tempOrder = this.state.PROorderReturnData;
    tempOrder.map((data) => {
      if (data.SKU === skuId && data.Type === 'Consumable') {
        if (cngValue <= parseInt(data.PackedQTY)) {
          data.ProcessedQTY = cngValue;
        } else {
          this.props.handleClick("tr", 3, 'Enter valid process quantity');
          // this.handleNotificationClick('tr', 3, 'Enter valid process quantity');
          return;
        }
      }
    });

    this.setState({
      PROorderReturnData: tempOrder
    });

    var tempPendingData = this.state.PROPending;
    tempPendingData.map((data) => {
      if (data.SKU === skuId && data.Type === 'Consumable') {
        if (cngValue <= parseInt(data.PackedQTY)) {
          data.DisQTY = data.PackedQTY - cngValue;
        }
      }
    });

    this.setState({
      PROPending: tempPendingData,
      PROScanEnterVerify: true
    });

  }

  async onPROScanSubmin() {


    if (this.state.PROScanEnterVerify == false) {
      this.props.handleClick("tr", 3, 'Scan or enter processed quantity');
      //this.handleNotificationClick('tr', 3, 'Scan or enter processed quantity');
      return;
    }

    document.getElementById("PROSubmitOne").disabled = true;
    document.getElementById("PROSubmitTwo").disabled = true;

    var ScanAssetDetails = [];
    this.state.PROScanData.map((data) => {
      var ScanAssetDetailsItem = {
        SerialNo: data.Serial,
        AssetId: data.AssetId
      }
      ScanAssetDetails.push(ScanAssetDetailsItem);
    });

    var UnScanAssetDetails = [];
    this.state.PROPending.map((data) => {
      if (data.Type === 'Asset') {
        var UnScanAssetDetailsItem = {
          SerialNo: data.Serial,
          AssetId: data.AssetId
        }
        UnScanAssetDetails.push(UnScanAssetDetailsItem);
      }
    });

    var tempitemDetails = [];
    this.state.PROorderReturnData.map((data) => {
      var itemDetails = {
        ItemId: data.ItemId,
        OrderedQuantity: data.PackedQTY,
        SentQuantity: data.mUnpackedQTY,
        ReceivedQuantity: data.mUnpackedQTY,
        DamagedQuantity: data.mDamageQTY,
        SKUId: data.SkuId,
        Description: data.ItemName,
        SKUType: data.Type,
        AskedQuantity: data.PackedQTY - data.mUnpackedQTY,
        ProcessedQuantity: data.ProcessedQTY,
        Status: true
      }
      tempitemDetails.push(itemDetails);
    });

    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }

    var SetRecord = {
      userid: warehouse_id,
      orderId: this.state.PROOrderID,
      BoxId: this.state.PROBoxid,
      requesttype: this.state.PRORequestType,
      ScanAssetDetails: ScanAssetDetails,
      UnScanAssetDetails: UnScanAssetDetails,
      itemDetails: tempitemDetails
    }
    //console.log('SetRecord');
    //console.log(SetRecord);

    await axios.post(config.get('API_URL') + '/inventory/ROReturnOrder', SetRecord, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      },
    }).then(response => {
      var boxId = response.data.boxDetails;
      this.props.handleClick("tr", 1, response.data.message);
      //this.handleNotificationClick('tr', 1, response.data.message);
      var url = 'https://data.innoviti.com:8443/barcode/?boxid=' + boxId;
      window.open(url, "_blank");
      // this.setState({
      //     viewType: 'tableView',
      //     title: 'Orders'
      // });
      setTimeout(function () {
        window.location.href = "/admin/orders";
      }.bind(this), 5000);

    })
      .catch((err) => {
        //console.log('PRO Error');
        //console.log(err);
      });

    //this.goBackOnOrder();
    setTimeout(function () {
      window.location.href = "/admin/orders";
    }.bind(this), 5000);
  }

  DispatchDetails(OrderId) {
    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }

    axios.get(config.get('API_URL') + '/inventory/DispathDetails?order_id=' + OrderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {

      //console.log(response);
      this.setState({
        disBoxDetails: response.data.BoxDetails,
        disOrderID: response.data.OrderID,
        disOrderName: response.data.OrderName,
        disawbNumber: response.data.awbNumber,
        disdeliveryDate: response.data.deliveryDate,
        disemployeeId: response.data.employeeId,
        dislogisticDetails: response.data.logisticDetails,
        disuserid: response.data.userid,

      });


    })
      .catch((err) => {
        //console.log(err);
      })

  }

  OnLogisticChange(e) {

    if (e.target.value === "Select...") {
      return false;
    }

    var index = e.target.selectedIndex;
    var txt = e.target[index].text;
    var awbTitle = '';
    if (txt === 'By Hand') {
      awbTitle = 'Employee Id';
    } else {
      awbTitle = 'AWB';
    }

    this.setState({
      AWBTitle: awbTitle,
      disSelectlogisticName: txt,
      disSelectlogisticId: e.target.value
    });

  }

  handleFromChange = date => { //alert(date);

    var date_filter = moment(date).format('YYYY-MM-DD');
    this.setState({
      expectDeliverDate: date_filter
    });

  };

  disAwbEmpChange(e) {
    this.setState({
      AwbEmp: e.target.value
    });
  }

  disBoxChange(e) {
    this.setState({
      BOX: e.target.value
    });
  }

  goBackOnOrder() {
    this.refreshOrders();
    this.setState({
      viewType: 'tableView'
    });

    // window.location.href='/admin/orders';
  }

  async onDisSubmit() {

    if (this.state.disSelectlogisticName === '' || this.state.disSelectlogisticName === 'Select...') {
      this.props.handleClick("tr", 3, 'Select logistic type.');
      // this.handleNotificationClick('tr', 3, 'Select logistic type.');
      return;
    }

    if (this.state.AwbEmp === '') {
      if (this.state.AWBTitle === 'AWB') {
        this.props.handleClick("tr", 3, 'Enter AWB Number.');
        // this.handleNotificationClick('tr', 3, 'Enter AWB Number.');
        return;
      } else {
        this.props.handleClick("tr", 3, 'Enter employee id.');
        //this.handleNotificationClick('tr', 3, 'Enter employee id.');
        return;
      }
    }

    if (this.state.BOX === '') {
      this.props.handleClick("tr", 3, 'Enter BOX number.');
      // this.handleNotificationClick('tr', 3, 'Enter BOX number.');
      return;
    }

    var chkBox = false;
    this.state.disBoxDetails.map((data) => {
      if (data.BoxName === this.state.BOX) {
        chkBox = true;
      } else {
        chkBox = false;
      }
    });

    if (chkBox === false) {
      this.props.handleClick("tr", 3, 'Enter valid BOX number.');
      //this.handleNotificationClick('tr', 3, 'Enter valid BOX number.');
      return;
    }

    document.getElementById("disSubmit").disabled = true;

    var tempAWB = null;
    var tempEmpId = null;
    if (this.state.AWBTitle === 'AWB') {
      tempAWB = this.state.AwbEmp;
    } else {
      tempEmpId = this.state.AwbEmp;
    }

    var tempLogistic = {
      logisticName: this.state.disSelectlogisticName,
      logisticId: this.state.disSelectlogisticId
    }

    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }


    var disSubmitData = {
      BoxDetails: this.state.disBoxDetails,
      OrderID: this.state.disOrderID,
      OrderName: this.state.disOrderName,
      awbNumber: tempAWB,
      deliveryDate: this.state.expectDeliverDate,
      employeeId: tempEmpId,
      logisticDetails: [tempLogistic],
      userid: warehouse_id,
    }


    await axios.post(config.get('API_URL') + '/inventory/DispatchSubmit', disSubmitData, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      },
    }).then(response => {
      this.props.handleClick("tr", 1, response.data.message);
      this.handleNotificationClick('tr', 1, response.data.message);
      //console.log(response);
    })
      .catch((err) => {
        //console.log('Error');
        //console.log(err);
      });

    this.getPDFDetails(this.state.disOrderID);

    this.setState({
      BOX: '',
      AwbEmp: ''
    });

    setTimeout(function () {
      window.location.href = "/admin/orders";
    }.bind(this), 5000);
  }

  async getPDFDetails(orderId) {

    await axios.get(config.get('API_URL') + '/inventory/getPdfDetails?order_id=' + orderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      //console.log('pdf');
      //console.log(response);

      this.setState({
        pdfBilledTo: response.data.BilledTo,
        pdfBoxDetails: response.data.BoxDetails,
        pdfInvoiceDetails: response.data.InvoiceDetails,
        pdfOrderItem: response.data.OrderItem,
        pdfShippedTo: response.data.ShippedTo
      });

      const uniqueData = [...new Set(this.state.pdfOrderItem.map(item => item.description))];
      const pdfTempData = [];
      for (var i = 0; i < uniqueData.length; i++) {
        var filterArray = this.state.pdfOrderItem.filter(function (el) {
          return el.description == uniqueData[i];
        });

        if (filterArray.length > 0) {
          const tempQty = filterArray.map(item => item.quantity).reduce((prev, curr) => prev + curr, 0);
          var tempLocalData = {
            description: filterArray[0].description,
            quantity: tempQty,
            rate: Number(filterArray[0].rate).toFixed(2),
            amount: Number(tempQty * filterArray[0].rate).toFixed(2),
            total: Number(tempQty * filterArray[0].rate).toFixed(2)
          }
          pdfTempData.push(tempLocalData)
        }
      }

      this.setState({
        pdfCustOrderItem: pdfTempData
      });
      //console.log('custom PDF data');
      //console.log(pdfTempData);
    })
      .catch(err => {
        //console.log(err);

      });

    var mywindow = window.open('', 'PRINT', 'height=842,width=595');
    mywindow.document.write('<html><body >');
    mywindow.document.write(document.getElementById('challanPDFforPrint').innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();

    mywindow.print();
    mywindow.close();

    return true;

  }

  toggleShowHide() {
    this.setState({
      DisputModal: !this.state.DisputModal,
    })
  }




  disputOrderSubmit() {
    var consumableDetails = [];
    var assetDetails = [];

    this.state.DisputAsset.map(data => {
      if (data.isScan == false) {
        var tempAssetData = {
          skuid: data.skuId,
          BoxItemID: data.BoxItemID,
          serialNo: data.AssetSerialNo
        }
        assetDetails.push(tempAssetData);
      }
    });

    //console.log(assetDetails);
    const token = localStorage.usertoken;
    let warehouse_id = '';
    if (token != null) {
      const decoded = jwt_decode(token);
      warehouse_id = decoded.warehouse_id
    }

    const body = JSON.stringify({
      userid: warehouse_id,
      orderId: this.state.encodedOrderId,
      boxDetails: this.state.boxSerialNumber,
      assetDetails: assetDetails,
      consumableDetails: consumableDetails
    });

    //console.log(body);
    axios.post(config.get('API_URL') + '/inventory/disput-Order',
      body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
        }
      }).then(response => {

      //console.log('disput');
      //console.log(response);


    }).catch(error => {
      //console.log('Failed to disput');
      //console.log(error);

    });
  }

  async ResendOTP() {
    var orderId = this.state.encodedOrderId;

    await axios.get(config.get('API_URL') + '/inventory/resend-otp?order_id=' + orderId, {
      headers: {
        Authorization: ` ${localStorage.usertoken}`,
        SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
      //console.log('resend otp');
      //console.log(response);
      this.props.handleClick("tr", 1, "OTP has been sent.");
      document.getElementById("btnOTP").disabled = true;

    })


    let seconds = 60;
    let myInterval = setInterval(() => {

      if (seconds > 0) {
        seconds = seconds - 1;
      }

      this.setState({
        interval: seconds
      });

      if (seconds === 0) {
        if (seconds === 0) {
          clearInterval(myInterval)
        } else {

          seconds = 60;
        }
      }
    }, 1000)

    setTimeout(function () {
      document.getElementById("btnOTP").disabled = false;

    }.bind(this), 61000);
  }

  _getOrdersByFilter(){
    console.log('Getting dates')
    console.log(moment(this.state.setStartDate).format('MM-DD-YYYY'))
    console.log(moment(this.state.setEndDate).format('MM-DD-YYYY'))
    console.log(this.state.searchOrderType)

  }

  
  render() {

    let orders_data = this.state.order_response.map((value, index) => {
      let createdDate = new Date(value.CreatedDate).toJSON().slice(0, 19).replace('T', ' ');
      let action = value.Action_WH__c;
      let concatOrderId = value.Id + ',' + value.Name + ',' + value.Fullfield_By__r.Facility_Type__c;
      let isLink = false;
      if (action != null) {
        if (action.includes('Add Inventory')) {
          action = 'Add Inventory';
          isLink = true;
        } else if (action.includes('Fulfill Order')) {
          action = 'Fulfill Order';
          isLink = true;
        } else if (action.includes('Inward Boxes')) {
          action = 'Inward Boxes';
          isLink = true;
        } else if (action.includes('Validate OTP')) {
          action = 'Validate OTP';
          isLink = true;
        } else if (action.includes('Verify Return Order')) {
          action = 'Verify Return Order';
          isLink = true;
        } else if (action.includes('Prepare Return Order')) {
          action = 'Prepare Return Order';
          isLink = true;
        } else if (action.includes('Dispatch')) {
          action = 'Dispatch';
          isLink = true;
        } else if (action.includes('NA')) {
          if (value.Actions__c === "No Open Orders" && value.Order_Status__c === "Closed") {
            action = 'Print DC';
            isLink = true;
          }
        }

      }

      let awb = value.AWB_Number__c;

      return (
        <tr key={index + 1}>
          <td>{value.Name}</td>
          <td>{value.Order_Type__c}</td>
          <td>{moment(createdDate).format('DD-MM-YYYY')}</td>
          <td>{value.Order_Status__c}</td>
          <td>{value.Ordered_Quantity__c}</td>
          <td>{value.Pending_Quantity__c}</td>

          <td>
            {isLink ?
              <Link name={concatOrderId} className="viewButton" data-tip={value.Actions__c} to="#"
                    onClick={this.handleView.bind(this)}>{action}</Link>
              : action}

          </td>
          <td>{value.Return_Action__c}</td>
          <td>{awb == undefined ? '' : awb}</td>
          <td>{value.Order_Fulfilled_By__c}</td>
        </tr>
      )
    });

    let boxDetailResponse = this.state.boxDetailResponse;
    let assetDataDetails = [];
    let consumableDataDetails = [];
    
    if (boxDetailResponse.length > 0) {
      let assetDetails = boxDetailResponse[0].AssetDetails;
      if (assetDetails.length > 0) {
        assetDataDetails = this.createInventoryTableView(assetDetails[0].Detailslist, 'asset', 0);
      }
      let consumableDetails = boxDetailResponse[0].ConsumablesDetails;
      if (consumableDetails.length > 0) {
        consumableDataDetails = this.createInventoryTableView(consumableDetails[0].Detailslist, 'consumable', assetDataDetails.length);
      }
    }

    let boxDetail = [...consumableDataDetails, ...assetDataDetails];

    let RODetail = this.state.orderReturnData.map((data, index) => {
      return (
        <tr key={index + 1}>
          <td>
            {data.SKU}
          </td>
          <td>
            {data.ItemName}
          </td>
          <td>{data.PackedQTY}</td>
          <td>
            {data.Type === 'Consumable' ?
              <input id={data.SKU} type="text"
                     onkeypress="if ( isNaN(this.value + String.fromCharCode(event.keyCode) )) return false;"
                     name={data.PackedQTY} value={data.ProcessedQTY} onChange={this.onROTxtChange.bind(this)}
              />
              :
              <label id={data.SKU}> {data.ProcessedQTY}</label>
            }
          </td>
        </tr>
      )
    });

    let pedingList = this.state.ROPending.map((data, index) => {
      return (
        <tr key={index + 1}>
          <td>{data.SKU}</td>
          <td>{data.ItemName}</td>
          <td>{data.assetSerialNumber} </td>
          <td>{data.Serial} </td>
          <td>{data.DisQTY}</td>
        </tr>
      )
    });

    let BomRODetail = this.state.BomorderReturnData.map((data, index) => {
      return (
        <tr key={index}>
          <th>{index+1}</th>
          <td>
            {data.SKU}
          </td>
          <td>
            {data.ItemName}
          </td>
          <td>{data.PackedQTY}</td>
          <td>
            {(data.Type === 'Consumable')?
              <input id={data.SKU} type="text"
                onkeypress="if ( isNaN(this.value + String.fromCharCode(event.keyCode) )) return false;"
                name={data.PackedQTY} value={data.ProcessedQTY}
                onChange={this.BomonROTxtChange.bind(this)}
              />
              :
              <label id={data.SKU}> {data.ProcessedQTY}</label>
            }
          </td>
        </tr>
      )
    });

    let BompedingList = this.state.BomROPending.map((data, index) => {
      return (
        <tr key={index}>
          <th>{index+1}</th>
          <td>{data.SKU}</td>
          <td>{data.ItemName}</td>
          <th>{data.Serial} </th>
          <td>{data.DisQTY}</td>
        </tr>
      )
    });


    let PRODetail = this.state.PROorderReturnData.map((data, index) => {
      return (
        <tr key={index + 1}>
          <td>
            {data.SKU}
          </td>
          <td>
            {data.ItemName}
          </td>
          <td>{data.PackedQTY}</td>
          <td>
            {data.Type === 'Consumable' ?
              <input id={data.SKU} type="text"
                     onkeypress="if ( isNaN(this.value + String.fromCharCode(event.keyCode) )) return false;"
                     name={data.PackedQTY} value={data.ProcessedQTY} onChange={this.onPROTxtChange.bind(this)}
              />
              :
              <label id={data.SKU}> {data.ProcessedQTY}</label>
            }
          </td>
        </tr>
      )
    });

    let PROpedingList = this.state.PROPending.map((data, index) => {
      return (
        <tr key={index + 1}>
          <td>{data.SKU}</td>
          <td>{data.ItemName}</td>
          <td>{data.Serial} </td>
          <td>{data.DisQTY}</td>
        </tr>
      )
    });


    let bindLogistic = this.state.dislogisticDetails.map((data) => {
      return (
        <option value={data.logisticId}>{data.logisticName}</option>
      )
    });

    //PDF data COde

    let pdfItemDetails = this.state.pdfCustOrderItem.map((data, index) => {
      return (
        <tr>
          <td align="center" colSpan={2}>
            {index + 1}
          </td>
          <td align="center" colSpan={5}>
            {data.description}
          </td>
          <td align="center" colSpan={4}>
            {'-'}
          </td>
          <td align="center" colSpan={1}>
            {data.quantity}
          </td>
          <td align="center" colSpan={1}>
            {data.rate}
          </td>
          <td align="center" colSpan={1}>
            {data.amount}
          </td>
          <td colSpan={1}/>
          <td colSpan={1}>

          </td>
          <td colSpan={1}/>
          <td colSpan={1}/>
          <td colSpan={1}/>
          <td colSpan={1}/>
          <td colSpan={1}/>
          <td colSpan={1}/>
          <td colSpan={2}>
            {data.total}
          </td>
        </tr>
      )

    });

    let pdfSeriaalDetails = this.state.pdfOrderItem.map((data, index) => {
      var NAtest = data.serialNo;

      if (String(NAtest) !== "NA") {
        return (
          <tr>

            <td>
              {index + 1}
            </td>
            <td>
            </td>

            <td>
              {data.serialNo}
            </td>
            <td>
              {data.description}
            </td>
          </tr>
        )
      }
    })

//END PDF data COde
    let ltDisputAsset = this.state.DisputAsset.map(data => {
      // console.log('data.isScan'+data.isScan);

      if (data.isScan == false) {
        return (
          <tr>
            <td>{data.skuName}</td>
            <td>{data.skuDesc}</td>
            <td>{data.AssetSerialNo}</td>
            <td>1</td>
          </tr>
        );
      }

    });

    //loader style
    const loading = {
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 111,
      backgroundColor: "#FFF",
      opacity: 0.75,
      width: "100%",
      height: "100%",
      display:"",
      margin:'auto'
    }

    return (
      <>
        {/* Loader div */}
        <div id="loaderId" style={{...loading, display:this.state.loader}}>
          <div style={{display:'block',marginTop:'50%', left:'50%',position: 'fixed', marginTop: '100px', marginLeft: '-50px'}}>
            <img src={loaderGIF} height={100} width={100} />
            <p className="text-center" style={{color:'#72287f'}}>Loading...</p>
          </div>
        </div>

      <div className="content">
        <NotificationSystem ref="notificationSystem" style={style}/>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 pt-5">
              <div>

                <div className="col-mid-12 no-padd">
                  <div className="card title-card-bottom-space">
                    <div className="header">
                      <div className="row">
                        <div className="col-md-3">
                          <h4 className="title">{this.state.title}</h4>
                        </div>

                        {/* <div className="col-md-9">
                          <div className="row" style={{backgroundColor:'', padding:8}}>
                            
                            <div className="col-md-3">
                              <label> Select Order Type</label>
                              <Select
                                name="orderType"
                                style={{}}
                                isClearable={false}
                                onChange={(v)=>this.setState({searchOrderType:v.value})}
                                options={[{value:'all', label: 'All'}, {value:'ro', label: 'Return Orders'},{value:'wo', label: 'Work Orders'}]}
                                defaultValue={{ label: "All", value: 'all' }}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 4,
                                  borderColor:'#72287f',
                                  fontSize:10,
                                  colors: {
                                    ...theme.colors,
                                    primary: '#f38120',
                                  },
                                })}
                              />
                              <div className="clearfix"></div>
                            </div>
                            
                            <div className="col-md-2">
                              <label> From date </label>
                              <DatePicker 
                                selected={this.state.setStartDate}
                                onChange={(date) => this.setState({setStartDate:date})}
                              />
                            </div>

                            <div className="col-md-2">
                              <label> To date </label>
                              <DatePicker 
                                selected={this.state.setEndDate}
                                onChange={(date) => this.setState({setEndDate:date})}
                              />
                            </div>

                            <div className="col-md-5">
                              <div style={{backgroundColor:'', marginTop:30}}>
                                <Button
                                  className="btn btn-primary"
                                  style={{marginRight:10,background:'#72287f',fontSize:15,color:'#fff'}}
                                  onClick={this._getOrdersByFilter.bind(this)}
                                >
                                  Search
                                </Button>
                              </div>
                            </div>
                            
                          </div>
                        </div> */}
                      </div>
                      
                    </div>
                  </div>
                </div>

                <div className="clearfix"></div>
                {this.state.viewType === 'tableView' ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="row">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="col-lg-12 ">

                          <div className="p-5">
                            <CSVLink data={this.state.ExcelData} headers={this.state.ExcelHeaders}>
                              <span className="btn btn-primary pull-right "> Export To Excel</span>
                            </CSVLink>
                            <br/>
                          </div>

                          <table className="table table-striped table-hover" id="ordersTable">
                            <thead>
                            <tr>
                              <th>Order id</th>
                              <th>Order type</th>
                              <th>Created date</th>
                              <th>Order status</th>
                              <th>Ordered quantity</th>
                              <th>Pending quantity</th>
                              <th>Actions</th>
                              <th>Return action</th>
                              <th>AWB Number</th>
                              <th>SRO</th>
                            </tr>
                            </thead>
                            <tbody>
                            {orders_data}
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                  : null}
                {this.state.viewType === 'Inward Boxes' ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-3 back-arrow-div">
                            <a href="#" onClick={this.showTableView.bind(this)}><i
                              className="fa fa-angle-left" aria-hidden="true"></i></a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="">
                            <div className="clearfix"></div>
                            <div className="gap_ver"></div>
                            <div className="col-md-4">
                              <label> Logistic </label>
                              <input name="logistic" className="form-control"
                                    value={this.state.logistic}
                                    onChange={this.handleInputBoxChange.bind(this)}
                                    disabled/>
                              <div className="clearfix"></div>
                            </div>
                            <div className="col-md-4">
                              <label> AWB </label>
                              <input name="awb" className="form-control"
                                    value={this.state.awb}
                                    onChange={this.handleInputBoxChange.bind(this)}
                                    disabled/>
                              <div className="clearfix"></div>
                            </div>
                            <div className="col-md-4">
                              <label> Challan number </label>
                              <input name="challanNumber" className="form-control"
                                     value={this.state.challanNumber}
                                     onChange={this.handleInputBoxChange.bind(this)}
                                     disabled/>
                              <div className="clearfix"></div>
                            </div>

                          </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>

                        <div className="Rule-al">
                          <label> Boxes </label>
                          <a href="#" className="addmore_rulesp-plus"
                             onClick={this.addInwardBox.bind(this)}>
                                                        <span className="glyphicon glyphicon-plus"
                                                              aria-hidden="true"></span>
                          </a>
                        </div>

                        {
                          this.state.inwardBoxes.map((inwardBox, index) => {
                            return (
                              <div key={index}>
                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>
                                <div className="row">
                                  <div className="col-md-4">
                                    <input type="text" className="form-control"
                                           name="inword_boxes"
                                           placeholder="Scanned box number"
                                           value={inwardBox}
                                           onChange={this.handleInwardBoxChange.bind(this, index)}/>
                                  </div>
                                  <div className="col-md-1">
                                    <a href="#" className="addmore_rulesp"
                                       onClick={this.removeInwardBox.bind(this, index)}>
                                      <i className="fa fa-trash"
                                         aria-hidden="true"></i>
                                    </a>
                                  </div>

                                </div>
                              </div>
                            )
                          })

                        }
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <button type="button" id="idBoxInward" className="btn btn-primary"
                                onClick={this.submitInwardBoxDetails.bind(this)}>Submit
                        </button>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <label>&nbsp;</label>
                      </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                  </React.Fragment>
                  : null}

                {this.state.viewType === 'Add Inventory' && !this.state.verifyInventoryView ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="clearfix"></div>
                        <div className="row">
                          <div className="">
                            <div className="col-md-4">
                              <label> Scan/enter box serial number </label>
                              <input name="boxSerialNumber" className="form-control"
                                    onChange={this.handleInputBoxChange.bind(this)}/>
                              <div className="clearfix"></div>
                            </div>
                          </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <div className="row">
                          <div className="">
                            <div className="col-md-1">
                              <button type="button" className="btn btn-primary"
                                      onClick={this.searchInventoryDetails.bind(this)}>Next
                              </button>
                              <div className="clearfix"></div>
                            </div>
                            <div className="col-md-1">
                              <button type="button" className="btn btn-secondary"
                                      onClick={this.showTableView.bind(this)}>Reset
                              </button>
                              <div className="clearfix"></div>
                            </div>
                          </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                      </div>
                    </div>
                  </React.Fragment>
                  : null}
                {this.state.viewType === 'Add Inventory' && this.state.verifyInventoryView && this.state.boxDetailResponse != null && this.state.boxDetailResponse.length > 0 ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-3 back-arrow-div">
                            <a href="#" onClick={this.showSearchBoxSerialView.bind(this)}><i
                              className="fa fa-angle-left" aria-hidden="true"></i></a>
                          </div>
                        </div>
                        <div className="">
                          <div className="row">
                            <div className="col-md-4">
                              <label> Scan/enter product serial number </label>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-4">
                              <input name="productSerialNumber" className="form-control"
                                     onChange={this.handleInputBoxChange.bind(this)}/>
                            </div>
                            <div className="col-md-2">

                              <button type="button" className="btn btn-primary"
                                      onClick={this.addProductSerialNumber.bind(this)}>Add
                              </button>

                            </div>

                          </div>
                          <div className="clearfix"></div>
                          <div className="gap_ver"></div>
                          <div className="hoz-line"></div>
                          <div className="">
                            <div className="">
                              <div
                                className="content-tdetails-table table-full-width table-responsive">
                                <table className="table-no-border" id="inventoryTable">
                                  <thead>
                                  <tr>
                                    <th>Verify</th>
                                    <th>SKU</th>
                                    <th>Item name</th>
                                    <th>Serial #</th>
                                    <th>Quantity</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {boxDetail}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div className="clearfix"></div>
                          <div className="gap_ver"></div>
                          <button id="btnVerifysubmitInventory" type="button" className="btn btn-primary"
                                  onClick={this.submitInventoryDetails.bind(this)}>Verify
                          </button>
                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                      </div>
                    </div>
                  </React.Fragment>
                  : null}

                {this.state.viewType === 'Fulfill Order' && !this.state.orderDetailOtpView ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-3 back-arrow-div">
                            <a href="#" onClick={this.showTableView.bind(this)}><i
                              className="fa fa-angle-left" aria-hidden="true"></i></a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="">
                            <div className="clearfix"></div>
                            <div className="gap_ver"></div>
                            <div className="col-md-4">
                              <label>Order Id </label>
                              <input name="FOAskQTY" className="form-control"
                                     value={this.state.orderId}
                                     onChange={this.handleInputBoxChange.bind(this)}
                                     disabled/>
                              <div className="clearfix"></div>
                            </div>
                            <div className="clearfix"></div>
                            <div className="gap_ver"></div>

                            <div style={{display: this.state.HideShowScan}}>
                              <div className="col-md-4">
                                <label> Serial No. Tracking </label>
                                <input name="FOScanSerialNo" className="form-control"
                                       value={this.state.FOScanSerialNo}
                                       onChange={this.FOhandleInputBoxChange.bind(this)}
                                />
                                <div className="clearfix"></div>
                              </div>
                              <div className="col-md-4">
                                <br/><br/>
                                <button type="button" className="btn btn-primary"
                                        onClick={this.FOOnScanClick.bind(this)}>Scan
                                </button>

                              </div>
                            </div>


                          </div>

                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <div className="hoz-line"></div>
                        <div className="">
                          <div className="">
                            <div
                              className="content-tdetails-table table-full-width table-responsive">
                              <table id="orderDetailsTable" className="table-no-border"
                                     width="100%">
                                <thead>
                                <tr>
                                  <th>SKU</th>
                                  <th>SKU Description</th>
                                  <th>Asked Quantity</th>
                                  <th>Processed Quantity</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.createOrderDetailsTableView()}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <button type="button" id="btnFOSubmitt" className="btn btn-primary"
                                onClick={this.submitOrderDetails.bind(this)}>Submit
                        </button>


                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                      </div>
                    </div>
                  </React.Fragment>
                  : null}

                {this.state.viewType === 'Fulfill Order' && this.state.orderDetailOtpView ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <div className="row">
                          <div className="row">
                            <div className="col-md-4">
                              <input name="otpValue" className="form-control"
                                     placeholder="" maxLength="6"
                                     value={this.state.otpValue}
                                     onChange={this.handleOtpInput.bind(this)}/>
                              <div className="clearfix"></div>
                            </div>
                            <div className="col-md-4 pad-3">
                              <button type="button" className="btn btn-primary"
                                      onClick={this.validateOtp.bind(this)}>Validate
                              </button>
                              {' '}
                              <button type="button" className="btn btn-secondary"
                                      onClick={this.showTableView.bind(this)}>Cancel
                              </button>
                              {' '}
                              <button type="button" id="btnOTP" className="btn btn-primary"
                                      onClick={this.ResendOTP.bind(this)}>Resend OTP
                              </button>
                              <small>{this.state.interval + ' Second'}</small>
                            </div>
                          </div>

                        </div>

                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>


                      </div>
                    </div>
                  </React.Fragment>
                  : null}

                {this.state.viewType === 'Validate OTP' && this.state.orderDetailOtpView ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">
                        <div className='sweet-loading'>
                          <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                          />
                        </div>
                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <div className="row">

                          <div className="col-md-4">
                            <label> Enter OTP </label>
                            <input name="otpValue" className="form-control" placeholder=""
                                   maxLength="6" value={this.state.otpValue}
                                   onChange={this.handleOtpInput.bind(this)}/>

                            <div className="clearfix"></div>
                            <br/>
                            <button type="button" className="btn btn-primary"
                                    onClick={this.validateOtp.bind(this)}>Validate
                            </button>
                            {' '}
                            <button type="button" className="btn btn-secondary"
                                    onClick={this.showTableView.bind(this)}>Cancel
                            </button>
                            {' '}
                            <button type="button" id="btnOTP" className="btn btn-primary"
                                    onClick={this.ResendOTP.bind(this)}>Resend OTP
                            </button>
                            <small>{this.state.interval + ' Second'}</small>

                          </div>


                        </div>

                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>


                      </div>
                    </div>
                  </React.Fragment>
                  : null}

                
                {this.state.viewType === 'Verify Return Order' && this.state.verifyROView && this.state.orderReturnData != null && this.state.orderReturnData.length > 0 ?

                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid" style={{height:'100vh'}}>
                        <div style={{padding:'10px 5px 80px 5px'}}>
                          <Tabs defaultActiveKey="showStocks" id="query-builder-tab" onSelect={this.handleSelectTab.bind(this)}>

                            {/* <-----------------------Verify Pending List Tab-----------------------------> */}
                            <Tab eventKey="showStocks" title="Verify">

                              <div className="p-10">
                                <div className='sweet-loading'>
                                  <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                  />
                                </div>

                                <div className="">

                                  <div className="row">
                                    <div className="col-md-6">
                                      <input
                                        id="serialDataInput" 
                                        name="BomproductSerialNumber"
                                        className="form-control invetoryUpperCase"
                                        onChange={this.BomhandleInputBoxChange.bind(this)}
                                        placeholder="Enter product serial number"
                                      />
                                    </div>
                                    <div className="col-md-6">
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        style={{marginRight:10,background:'#f38120',fontSize:15}}
                                        onClick={this.BomonROScanClick.bind(this)}>Scan</button>
                                    </div>
                                  </div>

                                  <div className="hoz-line" style={{marginTop:10}}></div>
                                    <div className="">
                                      <Table responsive>
                                        <thead>
                                          <tr>
                                            <th>#</th>
                                            <th>SKU</th>
                                            <th>Item name</th>
                                            <th>Asked QTY</th>
                                            <th>Processed QTY</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            this.state.emptyRO?
                                            <>
                                              <tr>
                                                <td style={{color:'#f00', fontSize:14}} colSpan={'100%'}>No items found for this Return Order, Kindly process manually</td>
                                              </tr>
                                            </>
                                            :
                                            BomRODetail
                                          }
                                        </tbody>
                                      </Table>
                                    </div>
                                </div>
                              </div>
                              <div className="text-center">
                                <div className="btn-group mr-2" style={{marginBottom:20}}>
                                  <button type="button" className="btn btn-primary" style={{marginRight:10,background:'#72287f',fontSize:15,color:'#fff'}} onClick={this.showTableView.bind(this)}>Cancel</button>
                                  <button type="button" className="btn btn-primary" style={{marginRight:10,background:'#f38120',fontSize:15,color:'#fff'}} id="BomROSubmitOne" onClick={this.onROScanSubmin.bind(this)}>Submit</button>
                                </div>
                              </div>

                            </Tab>
                            {/* <---------------End of Verify tab--------------> */}


                            {/* <---------------Pending list Tab----------------> */}
                            <Tab eventKey="checkStocks" title="Pending List">
                              <div className="p-10">
                                <div className='sweet-loading'>
                                  <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                  />
                                </div>

                                <div className="">
                                  <h3>List of Items in Return Order</h3>

                                  <div className="row">
                                    <div className="col-md-12">
                                      <Table responsive>
                                        <thead>
                                          <tr>
                                            <th>#</th>
                                            <th>SKU</th>
                                            <th>Item name</th>
                                            <th>Serial Number</th>
                                            <th>Quantity</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            this.state.emptyRO?
                                            <tr>
                                              <td colSpan={'100%'} style={{color:'#f00',fontSize:14}}>No Pending item list found for this return order</td>
                                            </tr>
                                            :
                                            BompedingList
                                          }
                                        </tbody>
                                      </Table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tab>
                            {/* <--------------End of pendig List------------------> */}
                            
                          </Tabs>  
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                : null}


                {this.state.viewType === 'RO Validate OTP' ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className="container-fluid">

                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>
                        <div className="row">

                          <div className="col-md-4">
                            <label> Enter OTP </label>
                            <input name="otpValue" className="form-control" placeholder=""
                                  maxLength="6" value={this.state.otpValue}
                                  onChange={this.handleOtpInput.bind(this)}/>

                            <div className="clearfix"></div>
                            <br/>
                            <button id="roValidateOTP" type="button" className="btn btn-primary"
                                    onClick={this.validateAndSubmintData.bind(this)}>Validate
                            </button>
                            {' '}
                            <button type="button" className="btn btn-secondary"
                                    onClick={this.showTableView.bind(this)}>Cancel
                            </button>
                            {' '}
                            <button type="button" id="btnOTP" className="btn btn-primary"
                                    onClick={this.ResendOTP.bind(this)}>Resend OTP
                            </button>
                            <small>{this.state.interval + ' Second'}</small>

                          </div>


                        </div>

                        <div className="clearfix"></div>
                        <div className="gap_ver"></div>


                      </div>
                    </div>
                  </React.Fragment>
                  : null}

                {this.state.viewType === 'Prepare Return Order' && this.state.verifyROView && this.state.PROorderReturnData != null && this.state.PROorderReturnData.length > 0 ?
                  <React.Fragment>
                    <div className="content bgcolor">
                      <div className=" container-fluid ">
                        <Tabs defaultActiveKey="showStocks" id="query-builder-tab"
                              onSelect={this.handleSelectTab.bind(this)}>
                          <Tab eventKey="showStocks" title="Verify">
                            <div className="p-10">
                              <div className='sweet-loading'>
                                <BeatLoader
                                  css={override}
                                  sizeUnit={"px"}
                                  size={20}
                                  color={'#123abc'}
                                  loading={this.state.loading}
                                />
                              </div>

                              <div className="">
                                <div className="row">
                                  <div className="col-md-4">
                                    <label> Scan/enter product serial
                                      number </label>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-3">
                                    <input name="productSerialNumber"
                                           className="form-control invetoryUpperCase"
                                           onChange={this.handleInputBoxChange.bind(this)}/>
                                  </div>
                                  <div className="col-md-3">
                                    <button type="button" className="btn btn-secondary"
                                            onClick={this.onPROScanClick.bind(this)}>Scan
                                    </button>
                                    {' '}
                                    <button type="button"
                                            className="btn btn-primary" id="PROSubmitOne"
                                            onClick={this.onPROScanSubmin.bind(this)}>Submit
                                    </button>
                                  </div>

                                </div>
                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>
                                <div className="hoz-line"></div>
                                <div className="">
                                  <div className="">
                                    <div
                                      className="content-tdetails-table table-full-width table-responsive">
                                      <table className="table-no-border"
                                            id="PROTable">
                                        <thead>
                                        <tr>
                                          <th>SKU</th>
                                          <th>Item name</th>
                                          <th>Asked QTY</th>
                                          <th>Processed QTY</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {PRODetail}
                                        </tbody>
                                      </table>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="gap_ver"></div>
                                    <button type="button" id="PROSubmitTwo"
                                            className="btn btn-primary" onClick={this.onPROScanSubmin.bind(this)}>Submit
                                    </button>
                                    {' '}
                                    <button type="button" className="btn btn-secondary"
                                            onClick={this.showTableView.bind(this)}>Cancel
                                    </button>
                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="gap_ver"></div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                          <Tab eventKey="checkStocks" title="Pending List">
                            <div className="p-10">
                              <div className='sweet-loading'>
                                <BeatLoader
                                  css={override}
                                  sizeUnit={"px"}
                                  size={20}
                                  color={'#123abc'}
                                  loading={this.state.loading}
                                />
                              </div>

                              <div className="">

                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>
                                <div className="hoz-line"></div>
                                <div className="">
                                  <div className="">
                                    <div
                                      className="content-tdetails-table table-full-width table-responsive">
                                      <table className="table-no-border"
                                            id="PROPendingTable">
                                        <thead>
                                        <tr>
                                          <th>SKU</th>
                                          <th>Item name</th>
                                          <th>Serial</th>
                                          <th>QTY</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {PROpedingList}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>

                              </div>
                              <div className="clearfix"></div>
                              <div className="gap_ver"></div>
                            </div>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>


                  </React.Fragment>
                  : null}

                {this.state.viewType === 'Dispatch' ?
                  <React.Fragment>
                    <div className=" content bgcolor">
                      <div className=" container-fluid ">

                        <div className="p-10">
                          <div className='sweet-loading'>
                            <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={20}
                              color={'#123abc'}
                              loading={this.state.loading}
                            />
                          </div>

                          <div className="">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="col-md-2"></div>
                                <div className="col-md-8 invetoryBox">
                                  <h4 className="invetoryTextCenter InventoryPeddingTop0">BOX Outward</h4>

                                  <hr/>
                                  <div className="col-md-4">
                                    <label> *Order </label>
                                    <input name="Order" className="form-control " value={this.state.disOrderName}
                                          disabled/>
                                  </div>
                                  <div className="col-md-4">
                                    <label> Logistic </label>
                                    <select id="Logistic" name="Logistic" className="form-control"
                                            onChange={(e) => this.OnLogisticChange(e)}>
                                      <option value="Select...">Select...</option>
                                      {bindLogistic}
                                    </select>

                                  </div>
                                  <div className="col-md-4">
                                    <label> {this.state.AWBTitle} </label>
                                    <input name="AWB" className="form-control" value={this.state.AwbEmp}
                                          onChange={this.disAwbEmpChange.bind(this)}/>
                                  </div>
                                  <div className="clearfix"></div>
                                  <br/>

                                  <div className="col-md-4">
                                    <label> Expected Delivery Date </label>
                                    <DatePicker
                                      dateFormat="dd-MM-yyyy"
                                      selected={Date.parse(this.state.expectDeliverDate)}
                                      onChange={this.handleFromChange}
                                      minDate={new Date()}
                                    />

                                  </div>

                                  <div className="col-md-8">
                                    <label>BOX</label>
                                    <input name="BOX" className="form-control " value={this.state.BOX}
                                          onChange={this.disBoxChange.bind(this)}/>
                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="gap_ver"></div>
                                  <hr/>
                                  <div className="col-md-12 invetoryTextCenter">
                                    <button type="button" id="disSubmit" className="btn btn-primary"
                                            onClick={this.onDisSubmit.bind(this)}>Submit
                                    </button>
                                    {' '}

                                    <button type="button" className="btn btn-secondary"
                                            onClick={this.goBackOnOrder.bind(this)}>Cancel
                                    </button>

                                  </div>

                                  <div className="col-md-3">

                                  </div>

                                </div>
                                <div className="col-md-2"></div>

                              </div>

                            </div>
                            <div className="">
                              <div className="">
                              </div>
                              <div className="clearfix"></div>
                              <div className="gap_ver"></div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>


                  </React.Fragment>
                  : null}


                <div id="challanPDFforPrint" style={{display: 'none'}}>
                  <div className="slds-box slds-theme_default">
                    <table border={1} style={{borderBottom: 0}} cellSpacing={0} width="100%">
                      
                      <tbody>
                        {/* 1 Company name */}
                        <tr align="center">
                          <td
                            height="65px"
                            align="center"
                            style={{borderBottom: "1px solid #3A3B3B"}}
                          >
                            <p style={{margin: 10, fontSize: 25}} align="center">
                              <b>INNOVITI TECHNOLOGIES PRIVATE LIMITED</b>
                            </p>
                          </td>
                        </tr>
                        {/* 2 address and GST */}
                        <tr>
                          <td
                            bgcolor="#fff"
                            align="center"
                            height={50}
                            style={{borderBottom: "1px solid #3A3B3B"}}
                          >
                            <p style={{margin: 10, fontSize: 12}} align="center">
                              Tower C, 2nd Floor, Diamond District,Old Airport Road, Kodihalli,Bangalore – 560008
                              Karnataka, India
                              <br/>
                              <span style={{fontSize:15}}>GSTIN 29AABCI0504M1ZN</span>
                            </p>
                          </td>
                        </tr>
                        {/* 3 Title */}
                        <tr>
                          <td
                            bgcolor="#fff"
                            height={50}
                            style={{borderBottom: "1px solid #3A3B3B", lineHeight: 0}}
                          >
                            <p style={{margin: 10, fontSize: 25}} align="center">
                              <b>Delivery challan</b>
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td style={{lineHeight: 2}}>
                            <table border={0} cellSpacing={0} width="100%">
                              <tbody>
                              <tr>
                                <td width="50%">

                                  <span
                                    style={{marginLeft: 10}}>
                                    Order no: {this.state.pdfBoxDetails.OrderId}
                                  </span>

                                  <br/>
                                  
                                  <span
                                    style={{marginLeft: 10}}>
                                    Invoice No: {String(this.state.pdfInvoiceDetails.InvoiceNo)}
                                  </span>
                                  
                                  <br/>

                                  <span style={{marginLeft: 10}}>
                                    Invoice date: {this.state.pdfInvoiceDetails.InvoiceDate}
                                  </span>


                                </td>
                                
                                <td
                                  width="50%"
                                  style={{
                                    borderLeft: "1px solid black",
                                    borderCollapse: "collapse"
                                  }}
                                >
                                  <span style={{marginLeft: 10}}> Transportation Mode</span>
                                  <br/>

                                  <span style={{marginLeft: 10}}>
                                    AWB No/By Hand:{this.state.pdfBoxDetails.AWBNo == null ? '..................' : this.state.pdfBoxDetails.AWBNo}
                                  </span>
                                  <br/>
                                  
                                  <span style={{marginLeft: 10}}>
                                    BOX No:{this.state.pdfBoxDetails.BoxNo == null ? '..................' : this.state.pdfBoxDetails.BoxNo}
                                  </span>
                                  
                                  <br/>

                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                      </tbody>
                    
                    </table>

                    <table
                      border={1}
                      cellPadding={0}
                      cellSpacing={0}
                      width="100%"
                      style={{borderBottom: 1, borderColor: "black"}}
                    >
                      <thead>
                      <tr>
                        <th/>
                        <th align="center" colSpan={12}>
                          Details of Billed To
                        </th>
                        <th align="center" colSpan={12}>
                          Details of consignee / Shipped By
                        </th>
                      </tr>
                      </thead>
                      <tbody>

                        <tr align="center" style={{height: 30}}>
                          <td>Name</td>
                          <td colSpan={12}>
                            {this.state.pdfBilledTo.Name}
                          </td>
                          <td colSpan={12}>
                            {this.state.pdfShippedTo.Name}
                          </td>
                        </tr>

                        <tr align="center" style={{height: 100}}>
                          <td>Address</td>
                          <td colSpan={12}>
                            {this.state.pdfBilledTo.Address}
                          </td>
                          <td colSpan={12}>
                            {this.state.pdfShippedTo.Address}
                          </td>
                        </tr>

                        <tr align="center" style={{height: 30}}>
                          <td>GSTIN</td>
                          <td colSpan={12}>
                            {this.state.pdfBilledTo.GSTIN == null ? 'none' : this.state.pdfBilledTo.GSTIN}
                          </td>
                          <td colSpan={4}>B2C</td>
                          <td colSpan={4}>Contact Person</td>
                          <td
                            colSpan={4}>{this.state.pdfBilledTo.ContactPerson == null ? '' : this.state.pdfBilledTo.ContactPerson}</td>
                        </tr>

                        <tr align="center" style={{height: 30}}>
                          <td colSpan={6}>State: {this.state.pdfBilledTo.State!=null?this.state.pdfBilledTo.State:'none'}</td>
                          <td colSpan={6}>City: {this.state.pdfBilledTo.City!=null?this.state.pdfBilledTo.City:'none'}</td>
                          <td colSpan={6}>Pin code: {this.state.pdfBilledTo.Zipcode!=null?this.state.pdfBilledTo.Zipcode:'none'}</td>
                          <td colSpan={6}>Contact no: {this.state.pdfBilledTo.ContactPersonMobileNo!=null?this.state.pdfBilledTo.ContactPersonMobileNo:'none'}</td>

                        </tr>
                      </tbody>
                    </table>

                    <table
                      border={1}
                      cellPadding={1}
                      cellSpacing={0}
                      width="100%"
                      style={{fontSize: 10, borderBottom: 0, borderColor: "black", borderTop:0}}
                    >
                      <thead>
                      <tr>
                        <th rowSpan={2} colSpan={2}>
                          SL NO
                        </th>
                        <th rowSpan={2} colSpan={5}>
                          DESCRIPTION OF GOODS
                        </th>
                        <th rowSpan={2} colSpan={4}>
                          HSN/SAC
                        </th>
                        <th rowSpan={2} colSpan={1}>
                          QTY
                        </th>
                        <th rowSpan={2} colSpan={1}>
                          RATE
                        </th>
                        <th rowSpan={2} colSpan={1}>
                          AMOUNT
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          LESS:
                        </th>
                        <th rowSpan={2} colSpan={1}>
                          TAXABLE VALUE
                        </th>
                        <th rowSpan={1} colSpan={2}>
                          CGST
                        </th>
                        <th rowSpan={1} colSpan={2}>
                          SGST
                        </th>
                        <th rowSpan={1} colSpan={2}>
                          IGST
                        </th>
                        <th rowSpan={2} colSpan={2}>
                          TOTAL
                        </th>
                      </tr>
                      <tr>
                        <th rowSpan={1} colSpan={1}>
                          DISCOUNT
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          RATE
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          AMOUNT
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          RATE
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          AMOUNT
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          RATE
                        </th>
                        <th rowSpan={1} colSpan={1}>
                          AMOUNT
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {pdfItemDetails}

                      <tr>
                        <td align="center" colSpan={11}>
                          Total
                        </td>
                        <td align="center" colSpan={1}>
                          {this.state.pdfCustOrderItem.reduce((a, b) => +a + +b.quantity, 0)}
                        </td>
                        <td align="center" colSpan={1}/>
                        <td align="center" colSpan={1}>
                          {this.state.pdfCustOrderItem.reduce((a, b) => +a + +b.amount, 0).toFixed(2)}
                        </td>
                        <td align="center" colSpan={1}/>
                        <td align="center" colSpan={1}>
                          {}
                        </td>
                        <td align="center" colSpan={1}/>
                        <td align="center" colSpan={1}>
                          0
                        </td>
                        <td align="center" colSpan={1}/>
                        <td align="center" colSpan={1}>
                          0
                        </td>
                        <td align="center" colSpan={1}/>
                        <td align="center" colSpan={1}/>
                        <td align="center" colSpan={2}>

                          {this.state.pdfCustOrderItem.reduce((a, b) => +a + +b.amount, 0).toFixed(2)}

                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <table
                      border={1}
                      cellPadding={1}
                      cellSpacing={0}
                      width="100%"
                      style={{fontSize: 10, borderBottom: 0, borderColor: "black"}}
                    >
                      <thead>
                      <tr align="center">
                        <th align="center" rowSpan={5} colSpan={11} style={{textTransform:'capitalize'}}>
                         {AmountInWords((this.state.pdfCustOrderItem.reduce((a, b) => +a + +b.amount, 0).toFixed(2))*100)}
                        </th>
                        <th colSpan={11}>Total Amount Before Tax:</th>
                      </tr>
                      <tr align="center">
                        <th colSpan={6}>Add CGST</th>
                        <th colSpan={1}>0</th>
                      </tr>
                      <tr align="center">
                        <th colSpan={6}>Add SGST</th>
                        <th colSpan={1}>0</th>
                      </tr>
                      <tr align="center">
                        <th colSpan={6}>Add IGST</th>
                        <th colSpan={1}>0</th>
                      </tr>
                      <tr align="center">
                        <th colSpan={6}>Total Amount After Tax:</th>
                        <th colSpan={1}>
                          {this.state.pdfCustOrderItem.reduce((a, b) => +a + +b.amount, 0).toFixed(2)}
                        </th>
                      </tr>
                      </thead>
                    </table>
                    
                    <h5>List of Items</h5>
                    <table
                      border={1}
                      cellPadding={1}
                      cellSpacing={0}
                      width="100%"
                      style={{fontSize: 15}}
                    >
                      <thead>
                      <tr align="center">
                        <th>SL No</th>
                        <th>Order #</th>
                        <th>Asset Serial #</th>
                        <th>Model</th>
                      </tr>
                      </thead>
                      <tbody>
                      {pdfSeriaalDetails}

                      </tbody>
                    </table>
                    
                  </div>
                  <div style={{fontSize: 15, marginTop: 30}}>
                    <b>(Goods are being dispatched for installation purpose)</b>
                    <p style={{marginTop: 100}}>
                      _____________________
                      <br/>
                      <b>
                        Authorized Signatory
                        <br/>
                        (Please affix company seal)
                      </b>
                    </p>
                  </div>
                </div>

                <ModalD visible={this.state.DisputModal}>
                  <ModalHeader toggle={this.toggleShowHide.bind(this)}>Disput Order Details</ModalHeader>
                  <div className="col-md-12">
                    <br/>
                    <div className="col-md-12  diyLogPeddingTop">
                      <table className="table table-striped table-hover dataTable no-footer">
                        <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Description</th>
                          <th>Serial</th>
                          <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        {ltDisputAsset}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <ModalFooter>
                    <Button color="primary" onClick={this.disputOrderSubmit.bind(this)}>Submit</Button>{' '}
                    <Button color="secondary" onClick={this.toggleShowHide.bind(this)}>Cancel</Button>
                  </ModalFooter>
                </ModalD>


                <ModalD visible={this.state.BomModal} width="50%">
                  <ModalHeader toggle={this.BOMtoggleShowHide.bind(this)}>BOM Item Details</ModalHeader>
                  <div className="col-md-12">
                    <br/>
                    <div className="col-md-12  diyLogPeddingTop">
                      <div className=" content bgcolor">
                        <div className=" container-fluid ">
                          <Tabs defaultActiveKey="showStocks" id="query-builder-tab"
                                onSelect={this.handleSelectTab.bind(this)}>
                            <Tab eventKey="showStocks" title="Verify">
                              <div className="p-10">
                                <div className='sweet-loading'>
                                  <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                  />
                                </div>

                                <div className="">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <label> Scan/enter product serial
                                        number </label>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4">
                                      <input name="BomproductSerialNumber" className="form-control invetoryUpperCase"
                                            onChange={this.BomhandleInputBoxChange.bind(this)}/>
                                    </div>
                                    <div className="col-md-6">
                                      <button type="button" className="btn btn-secondary"
                                              onClick={this.BomonROScanClick.bind(this)}>Scan
                                      </button>
                                      {' '}
                                      {/*<button  type="button" id="BomROSubmitOne"   className="btn btn-primary" onClick={this.BomonROScanSubmin.bind(this)}>Submit</button>*/}
                                    </div>

                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="gap_ver"></div>
                                  <div className="hoz-line"></div>
                                  <div className="">
                                    <div className="">
                                      <div
                                        className="content-tdetails-table table-full-width table-responsive">
                                        <table className="table-no-border"
                                              id="BomROTable">
                                          <thead>
                                          <tr>
                                            <th>SKU</th>
                                            <th>Item name</th>
                                            <th>Asked QTY</th>
                                            <th>Processed QTY</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          {BomRODetail}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="clearfix"></div>
                                      <div className="gap_ver"></div>
                                      {/*<button type="button" id="BomROSubmitTwo"  className="btn btn-primary" onClick={this.onROScanSubmin.bind(this)}>Submit </button>*/}
                                      {' '}
                                      {/*<button type="button" className="btn btn-secondary"*/}
                                      {/*        onClick={this.showTableView.bind(this)}>Cancel*/}
                                      {/*</button>*/}
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="gap_ver"></div>
                                  </div>
                                </div>
                              </div>
                            </Tab>
                            <Tab eventKey="checkStocks" title="Pending List">
                              <div className="p-10">
                                <div className='sweet-loading'>
                                  <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                  />
                                </div>

                                <div className="">

                                  <div className="clearfix"></div>
                                  <div className="gap_ver"></div>
                                  <div className="hoz-line"></div>
                                  <div className="">
                                    <div className="">
                                      <div
                                        className="content-tdetails-table table-full-width table-responsive">
                                        <table className="table-no-border"
                                              id="BomROPendingTable">
                                          <thead>
                                          <tr>
                                            <th>SKU</th>
                                            <th>Item name</th>
                                            <th>Serial</th>
                                            <th>QTY</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          {BompedingList}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="clearfix"></div>
                                  <div className="gap_ver"></div>

                                </div>
                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>
                              </div>
                            </Tab>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                  <ModalFooter>
                    <Button id="BomROSubmitOne" color="primary"
                            onClick={this.BomonROScanSubmin.bind(this)}>Submit</Button>{' '}
                    <Button color="secondary" onClick={this.BOMtoggleShowHide.bind(this)}>Cancel</Button>
                  </ModalFooter>
                </ModalD>


                <div className="footer">
                  <div className="stats"><i></i></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default Order;
